var _defs, _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFishandtipps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "fishandtipps_svg__Layer_1",
    viewBox: "0 0 1862 360.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n   .fishandtipps_svg__cls-1{fill:none}.fishandtipps_svg__cls-2{isolation:isolate}.fishandtipps_svg__cls-3{fill:#d2b27b}.fishandtipps_svg__cls-3,.fishandtipps_svg__cls-4,.fishandtipps_svg__cls-5,.fishandtipps_svg__cls-6,.fishandtipps_svg__cls-8{fill-rule:evenodd}.fishandtipps_svg__cls-4{fill:#b6aea0}.fishandtipps_svg__cls-5{fill:#eed398}.fishandtipps_svg__cls-6{fill:#c3a76d}.fishandtipps_svg__cls-7{fill:#54af84}.fishandtipps_svg__cls-8{fill:url(#fishandtipps_svg__linear-gradient)}.fishandtipps_svg__cls-9{fill:#b1dcc4}.fishandtipps_svg__cls-10{fill:#b9e0ca}.fishandtipps_svg__cls-11{fill:#398b5c}.fishandtipps_svg__cls-12{fill:#0c5236}.fishandtipps_svg__cls-13{fill:#d0eada}.fishandtipps_svg__cls-14{fill:#365729}.fishandtipps_svg__cls-15{fill:#6d8a3a}.fishandtipps_svg__cls-16{fill:#bcd977}.fishandtipps_svg__cls-17{fill:#80a13e}.fishandtipps_svg__cls-18{fill:#b6d54f}.fishandtipps_svg__cls-19{fill:#94a93b}.fishandtipps_svg__cls-20{fill:#add253}.fishandtipps_svg__cls-21{clip-path:url(#fishandtipps_svg__clip-path)}.fishandtipps_svg__cls-22{fill:url(#fishandtipps_svg__pattern)}.fishandtipps_svg__cls-23{fill:#c3d52e}.fishandtipps_svg__cls-24{fill:#daba90}.fishandtipps_svg__cls-25{fill:#b28c68}.fishandtipps_svg__cls-26{fill:#fcfae2}.fishandtipps_svg__cls-27{fill:#fffef6}.fishandtipps_svg__cls-28{fill:#bc9267}.fishandtipps_svg__cls-29{fill:#996244}.fishandtipps_svg__cls-30{clip-path:url(#fishandtipps_svg__clip-path-2)}.fishandtipps_svg__cls-31{fill:url(#fishandtipps_svg__pattern-2-2)}.fishandtipps_svg__cls-32{fill:#8a277f}.fishandtipps_svg__cls-33{fill:#3e0c38}.fishandtipps_svg__cls-34{fill:#7b2e73}.fishandtipps_svg__cls-35{fill:#aa2287}.fishandtipps_svg__cls-36{fill:#65205d}.fishandtipps_svg__cls-37{fill:#ef549e}.fishandtipps_svg__cls-38{fill:#32142f}.fishandtipps_svg__cls-39{fill:#7ab5e3}.fishandtipps_svg__cls-40{fill:#08505d}.fishandtipps_svg__cls-41{fill:#fff}.fishandtipps_svg__cls-42{fill:#e54699}.fishandtipps_svg__cls-43{fill:#ad2065}.fishandtipps_svg__cls-44{fill:#f16c9e}.fishandtipps_svg__cls-45{fill:#d79fc8}.fishandtipps_svg__cls-46{fill:#d5df2c}.fishandtipps_svg__cls-47{clip-path:url(#fishandtipps_svg__clip-path-3)}.fishandtipps_svg__cls-48{fill:url(#fishandtipps_svg__pattern-3)}.fishandtipps_svg__cls-49{clip-path:url(#fishandtipps_svg__clip-path-4)}.fishandtipps_svg__cls-50{fill:url(#fishandtipps_svg__pattern-4)}.fishandtipps_svg__cls-51{fill:#e63b26}.fishandtipps_svg__cls-52{fill:#cd2028}.fishandtipps_svg__cls-53{fill:#f15e2b}.fishandtipps_svg__cls-54{fill:#f5843e}.fishandtipps_svg__cls-55{fill:#fdbe6a}\r\n  "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fishandtipps_svg__linear-gradient",
    x1: 776.32,
    x2: 776.31,
    y1: 773.64,
    y2: 773.64,
    gradientTransform: "matrix(72.91, 0, 0, -65.77, -56098.14, 51130.71)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#329451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357753"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fishandtipps_svg__clip-path",
    transform: "translate(-35.75 -38.86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.15,244.24c1.28,2.77.32,6.73.75,10,.84,6.25,7,10.18,12.47,13.24,6.35,3.53,12.8,7.1,19.88,8.72,5.87,1.34,12.31,1.17,17.71-1.34h0l.26.37c1.43,2.15-1.13,4.89-3.38,6.15-6.37,3.58-13.92,4.27-21.22,4.78-14.23,1-28.77,1.52-42.52-2.27-4.38-1.2-9.25-3.49-10.22-7.92-.57-2.57.36-5.21,1.43-7.61,4.84-10.88,13.6-20.62,24.84-24.16Z",
    className: "fishandtipps_svg__cls-1"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "fishandtipps_svg__pattern",
    width: 77.93,
    height: 77.93,
    patternTransform: "translate(465.21 534.98) rotate(-180)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 77.93 77.93"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.93,
    height: 77.93,
    className: "fishandtipps_svg__cls-1"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAAA1CAYAAAC+2+58AAAACXBIWXMAAA2IAAANiAGC02DBAAACXklEQVR4Xu2YyXXDMAxEh3a6STcpKiWkinSSnqxc5GdK1gKAQ4Ci9E9aYJLGtxZP+vz5GrDHUsX82NZ+tj2sHJ9sP147t+dmdv4xpKx43H5kh8batDrvMJ7PxsnO37Ptj3HcfMb5d03Z3MPs3Hz/lm3/ff+mfJ/HvlISk7bImHckmDoCSNza6lUVOAI6bdQtv62tkAQ1W3AEMHkU2iz8+L3w81ssNbs9ASfDJkDzK5HUSmpqEjj/voDAxS0xfQWVEfXiI5l3X8ARMDwIk0HkHpKGz3EVYFlg77gKmKCRoakl8mwO/1p5ESegmO22pFrSyOPyBZAXSKXBeyBfAIkzxBAAQ0CnjfKIIQCGACYniyG2jl84oReg+ZVIaiU1Nak0v/R5vy1AOIgXR4ohpOivACPVGmF4ELYSQwCOAiYYF9sjMQI0BMnyiCEAtgC3ZhliCOs9IocwxByugAs1TQqIjiEk/4JZlAkIblQkjBgCKBXA5GQxxPORFCug4pc+CjoBmoZpaqOotEbNC9e6AMUgHvQYQwDaK8BItUYYHoQtxRCAk4AJBYvtEX8BGoJkecUQAFOAW7P6iSEApoALE80JOFMMAZQICG4UE+2/YFYMAZQIYBIcQ9RkK4ZYO1+OpCGSmppEzz+yLGDxTWLh2MUb2heuOlcAmcUYYuc+rG1EFNUFtNSI1mIIwEHAhMLFeuD5LxjwFqDhALIYcAS4NauvGAJgCbgw05SAs8UQgFVAcKOYRMYQgFUAkxPHEGs1ZUgaIqmpSfT8Ge8CrhjCjOWFi38FkOk5hgCANBxptR3yDwDDxAFm7LbDAAAAAElFTkSuQmCC",
    width: 95,
    height: 52,
    className: "fishandtipps_svg__cls-2",
    transform: "matrix(0.82, 0, 0, -0.82, 0, 60.3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fishandtipps_svg__clip-path-2",
    transform: "translate(-35.75 -38.86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.13,211.28a5,5,0,0,1,2.12-1.92,4.56,4.56,0,0,1,3.18.42,27.7,27.7,0,0,1,14.06,13.38A36.84,36.84,0,0,0,318.57,207c-2.62-4.48-6.35-9.14-5.27-14.22.87-4.15,3-9.61,8.22-9.26a28.84,28.84,0,0,1,9.11,11.05,40.45,40.45,0,0,1-.07-28.67,37.65,37.65,0,0,1,22.36,2.57,4.25,4.25,0,0,1,1.91,1.38,4.11,4.11,0,0,1,.45,2.46,37.91,37.91,0,0,1-8.68,22.81c4.36-2.12,9.51-3.08,14.12-1.57s8.44,5.91,8.29,10.77a4.9,4.9,0,0,1-1.07,3.19c-1.17,1.3-3.13,1.46-4.88,1.35-6-.37-11.83-.46-16.28-4.55,1,1.92-.9-2.86.1-.94-.65,6.8-2.57,9.7-2.1,13.36q-1.32,9.38-1.89,18.82a23.88,23.88,0,0,1,12.26-12c2.41,2,4.87,4.18,6.33,7s1.69,6.5-.28,9a10.43,10.43,0,0,1-3.78,2.69,30.84,30.84,0,0,1-11.15,2.91q-1.15,10.74-2.3,21.48a13,13,0,0,1-1.24,5.06,4.44,4.44,0,0,1-4.26,2.48l-3.78-2.59q-6.12-16.47-12.26-32.94A6.34,6.34,0,0,0,321,236a7.09,7.09,0,0,0-2.74-1.34,41.74,41.74,0,0,1-14.95-8.73,10.21,10.21,0,0,1-2.44-2.95C299,219.15,301.61,214.73,304.13,211.28Z",
    className: "fishandtipps_svg__cls-1"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "fishandtipps_svg__pattern-2-2",
    width: 104,
    height: 164,
    patternTransform: "matrix(0.66, 0, 0, -0.66, 229.53, 662.15)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 104 164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 164,
    className: "fishandtipps_svg__cls-1"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGgAAACkCAYAAAB7NmtuAAAACXBIWXMAAAsSAAALEgHS3X78AAADxklEQVR4Xu3cQXLbMAyFYTvDk/Ro3fb+2yiL1s04lkxSJMAfwvuWGUWG+URQki3f//z6vd0E66O2gaylgOAUEJwCglNAcAoITgHBKSA4BQSngOAUEJwCglNAcAoITgHBKSA4BQSngOBKbQN5tt18vyEwHJB3wdkUDTDb8Ay6rnttAxcdATEKzqZo4F+Rmn7TDCIV/GTDVjZN2RK8ych0oQrX1OLkPcseZBKQZcHxjI1GGfv3M/xfMbKiAWMzaXGR0Q7XakC0gi9t55JnwRrUQddot6JBWO9dAtUWt4IOmW/sFmfsHuBQeJpBEQqOZMZoFs9Q/F7J97Uslc/aFrLEY+IgTxL2eM50EtcWl82M7uQ6g2YUnI3WoAN3yAV88wyiFBzBzIO+eAz8zIKzUYuDnyTttDh2wQSeIzTlE9XxPciR1DdLz/JYtx+az+Le8SzYwmfnt5+3zu1H7J7FkQvOpvSGIQ0mdpQpLa5qYsE/2e2ZQV+eh/OZQUnNeLzUNaAZBWejh4jhXGcQFXkd3g2IXHA2OouDS9ribA5Ki73+C8hi11Z7zUVncS0WDtG5Frew4H6hin2hx0/gzs2gxTIdUtf5RPWinUAtrpP3aA23OO+CeWxHwKDFzd9jZlO+drVCzKr7Gcyga1l9r7J7DVpd8FUdjSr2bjazKn/pWxz9CcOXFkcv2ANpBJqeUa1vIac0LC+sFtdQ8NX9fF4Lf6sn+wNmesLO2uAE6L4OGjZYsLfV1Xa3uL6tZRTrJCG8+aNp3OLmF/xgt2cWfasHzngG5WB5P9MkIMuCs8HezZa/TGYQUdS1VicJcGlmEN3hJ6oHf1/OfF4HWXu/7yQEKTib7ntxss/qF1vMWpxVwV56fyDq3rd5s+bf6qEUnI3Lb5ZGRBmV5hZHKRjN4GC3/TzIoOBsUp/FRXjnTy0uQsEs9iM2ucXN3ZsEfj5oVJTO/r/FRSk4mxI+mPBv4L3UZ3EEtdFvvlD1Uis4m8lncfJisEP5z6DBgrO59Bp0hXemFgfn3+LcXOPQS3snwcOMkXWdQTMKDuvkm1+3Bi174ViKBmoPZ1AaWxyn4NW8R2L4JGHsv6Vm3RokTT5qG8hajWtQRNze0FPZ8Bo0w/oKuLQGrdQw+KwW11BwNrpQhWPNoERanw3GBNRacDZ6yhtOF6pwCghOAcEpIDgFBKeA4BQQnAKCU0BwCghOAcEpIDgFBKeA4BQQnAKCU0BwCghOAcEpIDgFBKeA4BQQnAKCU0BwCghOAcEpIDgFBKeA4BQQnAKCU0BwCgjuC2X9Ay782dGQAAAAAElFTkSuQmCC",
    width: 104,
    height: 164,
    className: "fishandtipps_svg__cls-2",
    transform: "matrix(1, 0, 0, -1, 0, 164)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fishandtipps_svg__clip-path-3",
    transform: "translate(-35.75 -38.86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1624.61,297.81c-.58,1.23-.14,3-.34,4.49-.37,2.79-3.11,4.55-5.58,5.92a34.4,34.4,0,0,1-8.89,3.9,12.48,12.48,0,0,1-7.93-.6h0l-.11.16c-.64,1,.5,2.19,1.51,2.75,2.85,1.6,6.23,1.92,9.49,2.14,6.37.45,12.88.68,19-1,2-.54,4.14-1.57,4.58-3.55a5.66,5.66,0,0,0-.64-3.4c-2.17-4.87-6.09-9.23-11.12-10.81Z",
    className: "fishandtipps_svg__cls-1"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "fishandtipps_svg__pattern-3",
    width: 55,
    height: 30,
    patternTransform: "matrix(0.63, 0, 0, -0.64, 1530.85, 542.87)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 55 30"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 30,
    className: "fishandtipps_svg__cls-1"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAAeCAYAAACIeIa4AAAACXBIWXMAAAsSAAALEgHS3X78AAABQ0lEQVRYR9WWWXbDIAxFr5zuprvp4rpc1I84LiEYMwii3B/FihmepOPz5Pv3R0mJM1qOmsuH+8MW5YLK/iAQ/vMS77NvJirHfrc9fgV47PD4T0K0Noobz3EeT6UTetgCXdiKe52Bc6J3Nfot2leAHLbiFiIV3XQt7pabhCSnhWmZJm5rGdELei/Zu66fs3EqtYDrT1FueVlcbfUv3gsnHwmp3b+TV3EVcz6dgfNiQUNjmZ2kMHAzY9rEaRKd0yaulTe6E7AU19LNBe4ELMUtpMadgGNxo+4EJonz4E6gtNbwggcL3QmMFeaOU3eimoqrmPPpDJyXdqq7c97dCbSI+zB3Ai3iWnmzOwErcS3dXOROwErcQmrdCTgVZ+FOYII4L+4EztYbXvBgsTuB0eI4dicQi6uY8+kMnJfrUlfnPsGdAPwB06eEAG606YUAAAAASUVORK5CYII=",
    width: 55,
    height: 30,
    className: "fishandtipps_svg__cls-2",
    transform: "matrix(1, 0, 0, -1, 0, 30)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fishandtipps_svg__clip-path-4",
    transform: "translate(-35.75 -38.86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1554.06,291.67a13.37,13.37,0,0,0-.16,2.83c-.19,1.77-1.54,2.88-2.76,3.74a15.57,15.57,0,0,1-4.39,2.46,4.92,4.92,0,0,1-3.92-.37l-.06.1c-.31.6.25,1.38.75,1.74a9,9,0,0,0,4.69,1.35c3.15.28,6.36.43,9.4-.64a3.08,3.08,0,0,0,2.26-2.24,4.4,4.4,0,0,0-.31-2.15c-1.07-3.07-3-5.82-5.49-6.82Z",
    className: "fishandtipps_svg__cls-1"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "fishandtipps_svg__pattern-4",
    width: 27,
    height: 19,
    patternTransform: "matrix(0.64, 0, 0, -0.63, 1471.96, 546.47)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 27 19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 19,
    className: "fishandtipps_svg__cls-1"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAATCAYAAABhh3Y4AAAACXBIWXMAAAsSAAALEgHS3X78AAAAz0lEQVRIS7WTURKDIAxEX7C36W16uN62ST+wJQJKbHFnHJHNsCHzlPvzYXxk7WP+W42koCaAwAtkrRHNNYvBTfO+aPZsTUicUCptgbq1eQOEVgkftq1vpaOCrOSbqL19y6nJKb37Sy2DfmJhJ3R04NbrdVbtZTiyxHuBKbeN1CTWXmct1kOi1fQxAtDBHk6E/Yt9eY/mPQF7iNwsiH1E47CgFjs+zDb+xdhD7z+7CHuYOMavdrCHYNgM7PN6NO9J2EPwZkW/Yw+jsOCBEewB3h3Cbff6ycNcAAAAAElFTkSuQmCC",
    width: 27,
    height: 19,
    className: "fishandtipps_svg__cls-2",
    transform: "matrix(1, 0, 0, -1, 0, 19)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fishandtipps_svg__Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_145",
    d: "M1897.75,243.61V399.17H35.75V217s15.86-2.56,37.55-5.46c11-1.49,23.59-3,36.34-4.4,13.75-1.45,27.68-2.66,40.15-3.25h.1c2.29-.11,4.5-.2,6.65-.25,6.06-.19,11.61-.19,16.49.05,11.71.57,28,1.83,45.42,3.37h0c16.6,1.45,34.19,3.18,50,4.75,22.72,2.3,41.46,4.31,47.53,5,1.35.16,2.07.23,2.07.23s17.88,2.2,42.23,4.53c17.6,1.69,38.56,3.45,58.58,4.51,20.44,1.07,39.95,1.4,53.87.17,46.39-4.09,154.68-11,154.68-11l26.43-1.48c39.22-2.17,108.64-6,112.8-6,5.79,0,193.34-4.29,193.34-4.29s110.2-1.21,127.63,0,5.78,2.23,77.32,7.35c55.53,4,142.55,14.12,221.23,22.76,17.91,2,35.4,3.87,52,5.59.72.09,1.49.17,2.21.24l10.74,1.1c11.23,1.14,23.87,2.15,37.42,3,1.24.1,2.52.17,3.81.26,17.91,1.16,37.27,2.11,57,2.9,15.32.61,30.84,1.12,46,1.54,21.72.63,42.79,1.05,61.56,1.34,9.46.15,18.33.26,26.4.33,27.68.24,46.36.11,48.16-.2.55-.09,2.6-.24,5.82-.4C1767,247.78,1897.75,243.61,1897.75,243.61Z",
    className: "fishandtipps_svg__cls-3",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_146",
    d: "M471.38,234.4a13.76,13.76,0,0,1-.16,2.72,28.15,28.15,0,0,1-1.79,6.3c0,.09-.07.19-.11.28-5.27,13.28-9.2,14.6-17.09,19.91s-36.76,9.3-43.33,10.64C405,275,356,261.71,305.33,253.32c-4.82-.79-9.67-1.55-14.49-2.25-13.63-1.95-27-3.43-39.46-4.06q-5-.24-9.8-.27c-2.81-.05-5.52,0-8.16.07a112.89,112.89,0,0,0-20.17,2.2l-2.11.46c-53.11,11.85-55.66,24.8-55.66,24.8s1.32,11.91-7.88,10.59c-2-.27-8.16-.07-16.62.21-7.77.28-17.55.63-27.87.67h0c-1.26,0-2.53.05-3.8,0-2.9,0-5.85,0-8.77-.1-23.27-.41-46.55-2.82-54.75-10.78v-236C58,49.39,71.45,63,71.45,63l11.33,17.2,7,10.69,13.77,17.41,2,2.52,23.62,3.3,14.44,2,26.27-9.3,27.59-1.34s11,1.44,22.88,3.34c5.56.9,11.31,1.93,16.27,3,3.16.65,6,1.3,8.19,1.94,3,.86,4.93,1.67,5.17,2.41.95,2.9,22.55,20.4,34.4,29.82C288.94,149.58,292,152,292,152s28.89,14.62,32.83,15.95,26.26-1.33,31.5,0,7.88-1.9,18.38.39,39.41,8.9,39.41,8.9l30.18,9.3s1.88-.74,5,2c2.74,2.39,6.47,7.42,10.76,18C466.67,222.58,471.22,227.87,471.38,234.4Z",
    className: "fishandtipps_svg__cls-4",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_147",
    d: "M1897.75,286.5V399.17H35.75V295.7s127.62-20.7,193.34,0c22.86,7.19,13,14.7-5.13,21.77-34,13.24-97.1,24.9-27.71,30,106.31,7.76,303.53,10.36,303.53,10.36s89.42-13.12,184.93-21.89c90.45-8.3,186.41-12.65,217,1.77,3.63,1.69,6.34,3.64,8,5.88,30.93,41.4-3.88,47.87,42.54,46.58s350,11.66,373.17-11.64-11.61-23.3-17.4-28.47-13.54-25.87-13.54-25.87,16.49-4.5,28.2-6.7c4.92-.92,9-1.46,10.63-1.07.94.21-.62.6-3.11,1.07-11.16,2.06-41,5.43,52.45,0,11.25-.65,24.35-1.44,39.45-2.36,64.33-4,123.3-6.22,174.29-8.16q23.89-.9,45.38-1.74c17.7-.72,34.09-1.46,49-2.3.94,0,1.87-.09,2.77-.14,23.25-1.32,42.82-2.9,58.13-5,7.07-1,13.24-2.08,18.43-3.33C1818.45,282.77,1897.75,286.5,1897.75,286.5Z",
    className: "fishandtipps_svg__cls-5",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_148",
    d: "M619.13,213.87C718.07,206.24,755.66,203,761.6,203H953.53s35.61,3.26,39.57,5.44,9.9,18.53,0,19.62-41.55,7.63-41.55,7.63,1.93,17.44,24.71,13.08,28.71-5.45,56.41-6.54,55.41-1.09,75.2-2.18,61.33,3.27,61.33,3.27,5.94,9.81,0,13.08-19.78,12-5.93,12,89-1.09,97,0,75.19,2.18,100.92,0,43.53-.75,102.89,1.26,83.1-10,166.21-10,124.65,1.09,152.36,0,100.91,1.09,100.91,1.09,23.74,5.16,9.9,9.12-27.7,11.59-39.58,11.59h-49.47s-67.27,8.72-93,7.63-87.06,4.55-108.83.1-114.76.3-124.65,1.74-61.34,6.88-77.17,6.88-97-1.09-108.83,0-51.44,5.45-64.31,6.54-62.32,3.27-56.39,7.63,31.66,4.36,33.64,12,15.83,19.62,13.85,27.25S1189,374.07,1189,374.07H1056.42l-69.25,6.54H961.44s-9.89-17.44-11.87-24-53.42-16.34-53.42-16.34-69.26-4.36-89-4.36H553.83s-102.89-2.18-148.4,1.09-43.18,12-76,8.18S263,337,241.21,335.93s-39.58,24-37.6-6.54,4-17.44,2-30.52-8.22-28.33-2.13-29.42,57.53,5.45,71.39,4.36,134.54-25.07,195.89-20.71S584.9,272.72,603,259.64s28-25.07,28-25.07Z",
    className: "fishandtipps_svg__cls-6",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_149",
    d: "M1897.75,232.92v121c-16.44-5.44-26.45-12.7-26.45-12.7L1859,327.77l-.83-.9-11.29-10.26-27.31-2.73-18.82,4.79-3.55.11-16.2.57s-10.11-1-19.84-2.13l-1.86-.23c-8.14-1-15.53-2.21-16-3.11-.3-.65-3.45-2.75-7.6-5.31-1.27-.78-2.62-1.61-4-2.44-8.49-5.07-18.5-10.7-18.5-10.7s-13.49-4.89-20.17-7.13c-.56-.18-1.07-.37-1.51-.5-.85-.28-1.5-.48-1.85-.57-2.8-.68-18.83.69-22.58,0s-5.66,1-13.17-.2l-3-.48c-9-1.41-25.22-4.09-25.22-4.09l-3.9-.86-12-2.65-2.13-.46-3.67-.82A4.42,4.42,0,0,1,1601,277a16,16,0,0,1-4.7-4.25c-.28-.33-.54-.68-.81-1.06a43.33,43.33,0,0,1-2.72-4.22c-5.21-9.2-8.67-11.55-8-15.5a11.08,11.08,0,0,1,1.4-3.63,20.87,20.87,0,0,1,4.54-6c.32-.28.67-.55,1-.8a48.71,48.71,0,0,1,6.68-3.49c3.33-1.62,12-3,19.4-4,5.14-.7,9.73-1.2,11.66-1.48a22.48,22.48,0,0,1,3.84.35c6.63.9,20.82,3.36,38,6,7.7,1.17,16,2.36,24.48,3.44,13.47,1.75,27.42,3.23,40.22,3.95,6,.33,11.82.5,17.15.43a117.69,117.69,0,0,0,16.56-1.17c6.51-1,12-2,16.62-3.06,23.46-5.15,24.78-9.92,24.78-9.92s-1-6.14,5.65-5.46C1823.1,227.78,1887.52,223.34,1897.75,232.92Z",
    className: "fishandtipps_svg__cls-4",
    transform: "translate(-35.75 -38.86)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "fishandtipps_svg__slice22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_100",
    d: "M501,272.82c.56-2.94.89-4.64,1.26-7.4,1.57-11.78-.88-24.36-8.14-33.77s-19.63-15.11-31.32-13c-15.6,2.85-25.93,17.82-32,32.5-2.53,6.16-4.51,13.56-.91,19.16a18.89,18.89,0,0,0,5.79,5.29c19.15,12.49,45.78,12.26,64.72-.55l.56-2.26Z",
    className: "fishandtipps_svg__cls-7",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_101",
    d: "M430.8,251.18c5.81-14.15,15.63-28.53,30.3-32.11-1.47,8.06.59,16.6,4.53,23.85,4.4,8.09,11,14.78,17.77,21,3.39,3.07,6.92,6.1,11.12,7.91a18.84,18.84,0,0,0,6.31,1.49l-.44,1.77c-18.93,12.8-45.57,13-64.72.54a18.83,18.83,0,0,1-5.78-5.28c-3.61-5.6-1.62-13,.9-19.16Z",
    className: "fishandtipps_svg__cls-8",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_102",
    d: "M462.76,218.68c11.69-2.14,24.06,3.56,31.32,13s9.71,22,8.14,33.76c-.37,2.77-.71,4.47-1.26,7.4l-.57,2.27c-.54.36-1.12.69-1.68,1,.19-8.91,0-17.93-3.3-26.18a38.46,38.46,0,0,0-30.64-23.58,37.91,37.91,0,0,0-21.44,4c5.26-5.85,11.7-10.24,19.43-11.66Z",
    className: "fishandtipps_svg__cls-9",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_103",
    d: "M467.32,232.24c1.19,2.45,3.52,3.75,5.22,2.92s2.12-3.49.93-5.93-3.53-3.76-5.23-2.93S466.13,229.79,467.32,232.24Z",
    className: "fishandtipps_svg__cls-10",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_104",
    d: "M475.74,249.18c.86,2.53,2.63,4.21,3.95,3.76s1.7-2.87.84-5.4-2.63-4.21-3.95-3.76S474.88,246.65,475.74,249.18Z",
    className: "fishandtipps_svg__cls-10",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_105",
    d: "M463.73,262.87c-.54,1.79.92,3.82,3.25,4.52s4.67-.19,5.2-2-.92-3.82-3.25-4.52S464.26,261.08,463.73,262.87Z",
    className: "fishandtipps_svg__cls-10",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_106",
    d: "M484.82,266.45a2.91,2.91,0,1,0,2.91-3A2.92,2.92,0,0,0,484.82,266.45Z",
    className: "fishandtipps_svg__cls-10",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_107",
    d: "M440.11,242.49a4.65,4.65,0,1,0,5.2-4c-.2,0-.4,0-.6,0A4.36,4.36,0,0,0,440.11,242.49Z",
    className: "fishandtipps_svg__cls-10",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_108",
    d: "M466.66,233.26c1.16,2.38,3.44,3.66,5.1,2.85s2.07-3.39.9-5.77-3.45-3.65-5.1-2.84S465.5,230.89,466.66,233.26Z",
    className: "fishandtipps_svg__cls-11",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_109",
    d: "M459.64,242.81Z",
    className: "fishandtipps_svg__cls-9",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_110",
    d: "M474.88,249.74c.84,2.46,2.57,4.09,3.86,3.65s1.66-2.79.82-5.25-2.57-4.09-3.86-3.65S474,247.28,474.88,249.74Z",
    className: "fishandtipps_svg__cls-11",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_111",
    d: "M463.16,263.05c-.52,1.74.9,3.72,3.18,4.4s4.54-.18,5.07-1.92-.9-3.71-3.18-4.4S463.68,261.31,463.16,263.05Z",
    className: "fishandtipps_svg__cls-12",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_112",
    d: "M483.74,266.53a2.84,2.84,0,1,0,2.84-2.9A2.88,2.88,0,0,0,483.74,266.53Z",
    className: "fishandtipps_svg__cls-12",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_113",
    d: "M440.11,243.24a4.53,4.53,0,1,0,5.09-3.9,3.9,3.9,0,0,0-.59,0A4.24,4.24,0,0,0,440.11,243.24Z",
    className: "fishandtipps_svg__cls-12",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_114",
    d: "M487.06,235.92c2.53,3.82,5.64,6.22,6.95,5.35s.31-4.66-2.22-8.49-5.66-6.22-7-5.35S484.52,232.1,487.06,235.92Z",
    className: "fishandtipps_svg__cls-13",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_115",
    d: "M494.74,246.39a1.85,1.85,0,0,0,1.7,2,2,2,0,0,0,0-3.94,1.85,1.85,0,0,0-1.7,2Z",
    className: "fishandtipps_svg__cls-13",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_116",
    d: "M442.58,273.24c4.43-19.18-8.47-37.79-21.61-52.46s-28.15-30.3-29.1-50c-.56-11.73,4.14-23.11,10.13-33.22,4.42-7.45,9.8-15.43,8.39-24a46.32,46.32,0,0,1-4.24,46.77h2.71a30.15,30.15,0,0,0,4,14.13,10.66,10.66,0,0,0-6.35,2.87,13,13,0,0,0,6.32,2.77l10.26,17.92c12.74,22.24,25.93,47.21,20.33,72.21Z",
    className: "fishandtipps_svg__cls-14",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_117",
    d: "M413.19,121.13a46.46,46.46,0,0,1-7,39.25h2.71a30.15,30.15,0,0,0,4,14.13,10.66,10.66,0,0,0-6.35,2.87,13.08,13.08,0,0,0,6.32,2.77l10.26,17.92c6.93,12.1,14,25,18.09,38.3-.12.15-.21.31-.33.47l-1.47,3.67c-3.8-15-12.44-28.34-22.16-40.39-7-8.73-15-17.59-16.77-28.67-1.77-11.23,3.27-22.25,7.56-32.77A73.08,73.08,0,0,0,413.19,121.13Z",
    className: "fishandtipps_svg__cls-15",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_118",
    d: "M403.55,159.64c3.74-2.58,5.89-6.9,7.32-11.21a53.36,53.36,0,0,0,2-25.21c.13-.7.24-1.4.34-2.09a46.46,46.46,0,0,1-7,39.25h2.71a30,30,0,0,0,4,14.13,10.66,10.66,0,0,0-6.35,2.87,13.08,13.08,0,0,0,6.32,2.77l10.26,17.92c2.36,4.12,4.73,8.33,7,12.62,0,.11,0,.22.05.32a171.54,171.54,0,0,1-17.21-26,6.07,6.07,0,0,0-1.62-2.17,11.46,11.46,0,0,0-2.37-1,6.55,6.55,0,0,1-3.93-6.42,7.41,7.41,0,0,1,5.3-3c-1.6-1.91-1.95-4.53-2.57-6.94s-1.85-5-4.19-5.81Z",
    className: "fishandtipps_svg__cls-16",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_119",
    d: "M451.48,269.71c10.06-21.45,35.48-32.08,46.69-52.95,7.77-14.48,7.57-32,4.82-48.17s-7.85-32-9.26-48.41l-9.36,26.32c-.65,1.83-3.74,3.42-3.78,1.49q3.14,7.77,6.26,15.52l-5.07.53a46.58,46.58,0,0,1-1.25,30.67c-1.76,4.39-4.24,9-2.93,13.58a231.81,231.81,0,0,0-27.73,59.55l1.61,1.87Z",
    className: "fishandtipps_svg__cls-17",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_120",
    d: "M453,266.83a8.56,8.56,0,0,1-1.49-4h0l.3,1.36c10.82-17.67,27.91-31,38-49.06a75.89,75.89,0,0,0,8.77-46.7c-1.25-9.14-4.17-18-5.67-27.1a52.09,52.09,0,0,1-.12-18.3c.33-1,.67-1.9,1-2.84,1.41,16.38,6.51,32.2,9.26,48.41s2.95,33.69-4.82,48.17C487.48,236.68,463.85,247.28,453,266.83Z",
    className: "fishandtipps_svg__cls-18",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_121",
    d: "M446,279.11c5.36-19.49,15.79-37.2,22.18-56.37s8.25-41.6-2.83-58.49l-4.4,2.07,1.38-8.4c-2.62.51-3.42-3.33-3.63-6-1.18-15.06-20.77-23.3-22.57-38.28q-.24,21.15,1.24,42.28c-2.5,1.91-1,5.87.76,8.52a77.42,77.42,0,0,0-2.42,33c.72,5.06,2.85,11,7.86,12a8,8,0,0,1-4.73,2.22,116.46,116.46,0,0,0,3.91,67.4l3.24.07Z",
    className: "fishandtipps_svg__cls-19",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_122",
    d: "M440.38,124c6.35,9.26,17.44,16.69,18.32,27.9.21,2.66,1,6.5,3.63,6q-.69,4.2-1.37,8.4l4.4-2.07c11.08,16.9,9.23,39.31,2.83,58.49-4.82,14.45-11.93,28.07-17.44,42.25a9.19,9.19,0,0,1-5.82,1.43l-1.67-2.05c15.25-45.23,14.06-95.75-2.87-140.35Z",
    className: "fishandtipps_svg__cls-20",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_123",
    d: "M436.13,113.67h0Z",
    className: "fishandtipps_svg__cls-20",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_124",
    d: "M459,274.91c-4.67-9-10.84-18.81-19.11-24.64s-18.8-8.87-28.71-6.82c-12.68,2.61-22.57,13.13-27.84,24.95-1.07,2.4-2,5.05-1.43,7.61,1,4.44,5.84,6.73,10.22,7.93,13.76,3.78,28.3,3.25,42.53,2.27,7.3-.51,14.84-1.21,21.22-4.79,2.24-1.26,4.8-4,3.37-6.14l-.25-.37Z",
    className: "fishandtipps_svg__cls-7",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "fishandtipps_svg__cls-21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fishandtipps_svg__Group_8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fishandtipps_svg__Rectangle_6",
    width: 77.93,
    height: 42.68,
    x: 345.96,
    y: 205.38,
    className: "fishandtipps_svg__cls-22"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_126",
    d: "M411.15,243.44c9.9-2.05,20.43,1,28.71,6.83S454.3,265.93,459,274.9l.26.37c.82,1.24.31,2.67-.69,3.9a37.22,37.22,0,0,0-21.7-22.61A42.42,42.42,0,0,0,404,258c-1.78.83-3.73,1.8-5.62,1.27-1.24-.35-2.27-1.31-3.54-1.47a5.48,5.48,0,0,0-3.61,1.31,37.47,37.47,0,0,0-5.55,4.74c5.6-9.86,14.5-18.09,25.51-20.36Z",
    className: "fishandtipps_svg__cls-9",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_127",
    d: "M413.28,265.3c-.48,1.94,1.06,4.06,3.46,4.74s4.74-.34,5.23-2.28-1.06-4.05-3.46-4.73S413.77,263.36,413.28,265.3Z",
    className: "fishandtipps_svg__cls-10",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_128",
    d: "M436.19,264a4,4,0,1,0,3.78-4.16l-.34,0A3.81,3.81,0,0,0,436.19,264Z",
    className: "fishandtipps_svg__cls-10",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_129",
    d: "M420,250.72a2.33,2.33,0,1,0,2.19-2.46l-.18,0a2.23,2.23,0,0,0-2,2.44Z",
    className: "fishandtipps_svg__cls-10",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_130",
    d: "M392.54,269.92c.26,2,2.62,3.31,5.24,3s4.54-2.26,4.27-4.25-2.61-3.31-5.24-3-4.54,2.26-4.27,4.25Z",
    className: "fishandtipps_svg__cls-10",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_131",
    d: "M416.81,279.72c-.19.85.64,1.8,1.86,2.11s2.35-.15,2.54-1-.63-1.81-1.85-2.11S417,278.85,416.81,279.72Z",
    className: "fishandtipps_svg__cls-10",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_132",
    d: "M413.37,266c-.5,1.86,1,3.9,3.43,4.53s4.74-.35,5.24-2.22-1-3.9-3.43-4.53S413.87,264.09,413.37,266Z",
    className: "fishandtipps_svg__cls-12",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_133",
    d: "M436.26,264.61a4,4,0,1,0,4-4l-.5,0A3.75,3.75,0,0,0,436.26,264.61Z",
    className: "fishandtipps_svg__cls-11",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_134",
    d: "M420.18,251.88a2.34,2.34,0,1,0,2.29-2.37,1.23,1.23,0,0,0-.27,0A2.19,2.19,0,0,0,420.18,251.88Z",
    className: "fishandtipps_svg__cls-11",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_135",
    d: "M392.62,270.5c.25,1.91,2.6,3.18,5.22,2.82s4.55-2.19,4.29-4.1-2.6-3.18-5.22-2.83-4.55,2.19-4.29,4.11Z",
    className: "fishandtipps_svg__cls-12",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_136",
    d: "M416.83,279.81c-.19.83.62,1.74,1.84,2s2.35-.16,2.55-1-.63-1.74-1.84-2-2.36.16-2.55,1Z",
    className: "fishandtipps_svg__cls-12",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_137",
    d: "M403.83,251c.37,1.53,3.09,2.18,6.07,1.45s5.1-2.56,4.73-4.08-3.1-2.19-6.08-1.46S403.45,249.5,403.83,251Z",
    className: "fishandtipps_svg__cls-13",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_138",
    d: "M431.19,251.57a1.82,1.82,0,1,0,1.8-2.07A1.94,1.94,0,0,0,431.19,251.57Z",
    className: "fishandtipps_svg__cls-13",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_139",
    d: "M438.89,223.43a107.65,107.65,0,0,0-2.15,23.28A12.53,12.53,0,0,0,436,248a115.65,115.65,0,0,1,2.86-36.33,8,8,0,0,0,4.73-2.22c-5-1-7.14-6.94-7.86-12a77.48,77.48,0,0,1,2.42-33c-1.72-2.64-3.26-6.6-.75-8.51q-1.49-21.1-1.26-42.28A20.59,20.59,0,0,0,438,120q.87,19.45,2.86,38.84l-2.42,2.09c1.69,2.56.69,6-.09,8.92a49.14,49.14,0,0,0,7.05,39.84C441.52,213.06,439.93,218.37,438.89,223.43Z",
    className: "fishandtipps_svg__cls-16",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_140",
    d: "M480.53,194.71A46.58,46.58,0,0,0,481.78,164l5.07-.53-6-14.87c.75.72,3-.62,3.51-2.15q4.68-13.16,9.37-26.31c1.41,16.37,6.51,32.2,9.26,48.41s2.95,33.69-4.82,48.17a53.52,53.52,0,0,1-3.73,5.92c.7-1.24,1.39-2.5,2-3.77,5.24-10.33,8.37-22.07,6.77-33.55-.91-6.54-3.32-12.76-5.06-19.13-3.39-12.4-4.25-25.33-4.74-38.17a64.27,64.27,0,0,1-8.33,22.26,134.77,134.77,0,0,1,3.73,17.54,6.13,6.13,0,0,1-3.56.43,47.78,47.78,0,0,1-4.35,33.84,9.44,9.44,0,0,0-1.35,3.43c-.07.8.09,1.6,0,2.41-.24,4.19-5.52,6.1-7.41,9.86.27-.7.5-1.4.75-2.1q2.25-3.76,4.64-7.44C476.29,203.74,478.77,199.1,480.53,194.71Z",
    className: "fishandtipps_svg__cls-16",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_141",
    d: "M480.59,148l.27.65A.89.89,0,0,1,480.59,148Z",
    className: "fishandtipps_svg__cls-16",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_142",
    d: "M439.64,122.41c21.7,39.09,24.82,88,8.27,129.52a291.63,291.63,0,0,0,2.13-93c-1.51-11-3.72-22.05-8.92-31.84Z",
    className: "fishandtipps_svg__cls-23",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_143",
    d: "M495.27,153a85.63,85.63,0,0,1-16.72,77.31c19.54-16,26.4-44.35,20.24-68.82Z",
    className: "fishandtipps_svg__cls-23",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_144",
    d: "M410.4,130.94c-4.74,9.24-9.08,18.88-10.64,29.15s-.05,21.36,6.05,29.77a87.39,87.39,0,0,0,6.66,7.61c8.3,9.09,14.86,19.58,21.37,30-2.09-11.19-9.61-20.46-16.66-29.39S403.05,179.38,402.09,168c-1-12.16,5.2-23.61,8.33-35.41Z",
    className: "fishandtipps_svg__cls-19",
    transform: "translate(-35.75 -38.86)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "fishandtipps_svg__slice6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_150",
    d: "M291.29,287.6c-.27-1.43-.43-2.27-.61-3.62-.77-5.75.43-11.9,4-16.49s9.59-7.38,15.3-6.34c7.62,1.4,12.67,8.71,15.61,15.88,1.24,3,2.21,6.62.44,9.35a9.31,9.31,0,0,1-2.82,2.59,29.27,29.27,0,0,1-31.61-.27l-.28-1.1Z",
    className: "fishandtipps_svg__cls-24",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_151",
    d: "M325.56,277c-2.84-6.91-7.64-13.94-14.8-15.68A18,18,0,0,1,308.54,273a40.25,40.25,0,0,1-8.68,10.25,20.22,20.22,0,0,1-5.43,3.87,9.36,9.36,0,0,1-3.08.72l.22.86a29.25,29.25,0,0,0,31.61.27,9.15,9.15,0,0,0,2.82-2.58c1.76-2.73.79-6.35-.44-9.35Z",
    className: "fishandtipps_svg__cls-25",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_152",
    d: "M310,261.15c-5.71-1-11.75,1.74-15.3,6.34s-4.74,10.74-4,16.49c.18,1.35.34,2.19.61,3.62l.28,1.1c.26.18.55.34.82.51-.09-4.35,0-8.76,1.61-12.79a18.78,18.78,0,0,1,15-11.52,18.56,18.56,0,0,1,10.48,2A17,17,0,0,0,310,261.15Z",
    className: "fishandtipps_svg__cls-26",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_153",
    d: "M307.72,267.78c-.58,1.2-1.72,1.83-2.55,1.42s-1-1.7-.45-2.9,1.72-1.83,2.55-1.43S308.31,266.58,307.72,267.78Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_154",
    d: "M303.61,276.05c-.42,1.24-1.29,2.06-1.93,1.84s-.83-1.4-.41-2.64,1.28-2.06,1.93-1.84S304,274.82,303.61,276.05Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_155",
    d: "M309.47,282.74a2,2,0,0,1-1.58,2.21,1.73,1.73,0,0,1-2.36-.56,1.71,1.71,0,0,1,.56-2.36,1.62,1.62,0,0,1,.85-.25A1.93,1.93,0,0,1,309.47,282.74Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_156",
    d: "M299.17,284.49a1.42,1.42,0,1,1-1.42-1.46,1.44,1.44,0,0,1,1.42,1.45Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_157",
    d: "M321,272.79a2.27,2.27,0,1,1-2.53-2,1.32,1.32,0,0,1,.28,0A2.12,2.12,0,0,1,321,272.79Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_158",
    d: "M308.05,268.28c-.57,1.16-1.69,1.78-2.5,1.39s-1-1.66-.44-2.82,1.68-1.78,2.5-1.39S308.61,267.12,308.05,268.28Z",
    className: "fishandtipps_svg__cls-28",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_159",
    d: "M311.48,272.94",
    className: "fishandtipps_svg__cls-9",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_160",
    d: "M304,276.33c-.41,1.2-1.26,2-1.89,1.78s-.81-1.36-.4-2.56,1.26-2,1.89-1.79S304.44,275.13,304,276.33Z",
    className: "fishandtipps_svg__cls-28",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_161",
    d: "M309.75,282.83A1.9,1.9,0,0,1,308.2,285a1.67,1.67,0,1,1-1.76-2.83,1.64,1.64,0,0,1,.83-.25A1.91,1.91,0,0,1,309.75,282.83Z",
    className: "fishandtipps_svg__cls-29",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_162",
    d: "M299.7,284.53a1.39,1.39,0,1,1-1.38-1.42A1.39,1.39,0,0,1,299.7,284.53Z",
    className: "fishandtipps_svg__cls-29",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_163",
    d: "M321,273.15a2.21,2.21,0,1,1-2.48-1.91l.29,0A2.08,2.08,0,0,1,321,273.15Z",
    className: "fishandtipps_svg__cls-29",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_164",
    d: "M298.09,269.58c-1.25,1.86-2.77,3-3.4,2.61s-.16-2.28,1.08-4.15,2.76-3,3.4-2.61S299.32,267.71,298.09,269.58Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_165",
    d: "M294.33,274.69a.91.91,0,0,1-.83,1,1,1,0,0,1,0-1.92A.9.9,0,0,1,294.33,274.69Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_166",
    d: "M329.66,289.21c3.92-7.52,9.09-15.77,16-20.65s15.76-7.44,24.07-5.73c10.63,2.2,18.92,11,23.34,20.93.9,2,1.67,4.23,1.2,6.38-.82,3.72-4.9,5.64-8.57,6.65-11.53,3.17-23.72,2.73-35.66,1.9-6.12-.43-12.44-1-17.79-4-1.89-1.06-4-3.36-2.83-5.15l.21-.32Z",
    className: "fishandtipps_svg__cls-24",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_167",
    d: "M372.27,263.51c-1.07,2.32-.26,5.64-.63,8.41-.7,5.24-5.84,8.53-10.45,11.1-5.32,3-10.73,6-16.67,7.31a23.29,23.29,0,0,1-14.85-1.12h0l-.22.31c-1.2,1.8.95,4.1,2.83,5.16,5.35,3,11.67,3.58,17.8,4,11.93.83,24.12,1.27,35.65-1.9,3.67-1,7.76-2.93,8.57-6.65.48-2.15-.3-4.37-1.2-6.38C389,274.64,381.69,266.47,372.27,263.51Z",
    className: "fishandtipps_svg__cls-25",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_168",
    d: "M369.76,262.84c-8.31-1.72-17.13.84-24.07,5.72s-12.11,13.13-16,20.65l-.21.31c-.69,1-.27,2.24.57,3.28a31.25,31.25,0,0,1,18.2-19A35.61,35.61,0,0,1,375.79,275c1.49.7,3.12,1.52,4.71,1.07,1-.3,1.9-1.1,3-1.23a4.55,4.55,0,0,1,3,1.09,31.46,31.46,0,0,1,4.65,4c-4.7-8.27-12.16-15.16-21.38-17.07Z",
    className: "fishandtipps_svg__cls-26",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_169",
    d: "M368,281.17c.41,1.62-.89,3.4-2.9,4s-4-.28-4.39-1.9.89-3.4,2.9-4S367.56,279.54,368,281.17Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_170",
    d: "M348.77,280.1a3.34,3.34,0,1,1-3.18-3.49l.29,0A3.21,3.21,0,0,1,348.77,280.1Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_171",
    d: "M362.32,268.94a2,2,0,1,1-1.84-2.06h.15A1.9,1.9,0,0,1,362.32,268.94Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_172",
    d: "M385.36,285c-.22,1.67-2.19,2.78-4.39,2.49s-3.81-1.89-3.58-3.56,2.19-2.78,4.39-2.48S385.59,283.37,385.36,285Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_173",
    d: "M365,293.25c.16.73-.54,1.52-1.56,1.78s-2-.13-2.13-.86.53-1.51,1.55-1.77S364.85,292.53,365,293.25Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_174",
    d: "M367.9,281.71c.41,1.57-.87,3.27-2.88,3.8s-4-.3-4.39-1.86.87-3.26,2.87-3.8S367.48,280.15,367.9,281.71Z",
    className: "fishandtipps_svg__cls-29",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_175",
    d: "M348.7,280.59a3.35,3.35,0,1,1-3.31-3.38,2.73,2.73,0,0,1,.41,0A3.13,3.13,0,0,1,348.7,280.59Z",
    className: "fishandtipps_svg__cls-28",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_176",
    d: "M362.19,269.92a2,2,0,1,1-1.92-2l.22,0a1.85,1.85,0,0,1,1.7,2Z",
    className: "fishandtipps_svg__cls-28",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_177",
    d: "M385.29,285.52c-.21,1.61-2.17,2.67-4.38,2.37s-3.81-1.83-3.6-3.44,2.18-2.67,4.38-2.37S385.51,283.92,385.29,285.52Z",
    className: "fishandtipps_svg__cls-29",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_178",
    d: "M365,293.33c.16.7-.53,1.46-1.55,1.7s-2-.13-2.13-.83.52-1.45,1.54-1.7S364.83,292.63,365,293.33Z",
    className: "fishandtipps_svg__cls-29",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_179",
    d: "M375.9,269.2c-.32,1.28-2.6,1.83-5.1,1.22s-4.27-2.15-4-3.43,2.59-1.83,5.1-1.21S376.21,267.92,375.9,269.2Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_180",
    d: "M353,269.66a1.53,1.53,0,1,1-1.52-1.74A1.64,1.64,0,0,1,353,269.66Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "fishandtipps_svg__cls-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fishandtipps_svg__Group_10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fishandtipps_svg__Rectangle_7",
    width: 68.79,
    height: 108.95,
    x: 264.48,
    y: 126.31,
    className: "fishandtipps_svg__cls-31"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_182",
    d: "M333,170.7a26.14,26.14,0,0,0,1,16.09c.8,2,2.23,4.19,4.4,4.3a5.64,5.64,0,0,0,2.22-.48,17.84,17.84,0,0,0,10.85-18.21,2.59,2.59,0,0,0-.29-1c-.49-.75-1.56-.75-2.44-.66l-10.72,1Z",
    className: "fishandtipps_svg__cls-32",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_183",
    d: "M363.82,204.33a8.54,8.54,0,0,0-.79-6.15c-1.53-2.36-4.63-3.19-7.44-3.06a9,9,0,0,0-5.4,1.85,3.41,3.41,0,0,0-1.1,1.57c-.37,1.37.6,2.72,1.61,3.73a22.07,22.07,0,0,0,3.64,2.9c2.48,1.58,5.76,2.63,8.3,1.13Z",
    className: "fishandtipps_svg__cls-32",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_184",
    d: "M347.14,172.5a34,34,0,0,1-6.32,15.65,10.23,10.23,0,0,0-1.38,2.17,9.34,9.34,0,0,0-.52,3.4q-.68,24.36-3.29,48.61a4,4,0,0,0,.37,2.77c.81,1.15,2.67,1.06,3.76.16a6.76,6.76,0,0,0,1.93-3.68c1.79-6.83,1.55-14,1.29-21.05l-.6-16.53,16.34-.7c.06-.94.11-1.88.16-2.82-5-.49-10.24-2.4-13.24-6.49a61.05,61.05,0,0,0,5.14-15.62,13.66,13.66,0,0,0-.07-7,3.76,3.76,0,0,0-2.16.38l-1.41.76Z",
    className: "fishandtipps_svg__cls-33",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_185",
    d: "M315.54,194.89a14.49,14.49,0,0,0,7,10.78,5.55,5.55,0,0,0,1.89.75,4.41,4.41,0,0,0,4.29-2.51,9.4,9.4,0,0,0,.72-5.18,17.68,17.68,0,0,0-5-11.21,1.31,1.31,0,0,0-.56-.37,1.29,1.29,0,0,0-.75.13,9.59,9.59,0,0,0-3.7,2.69Z",
    className: "fishandtipps_svg__cls-32",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_186",
    d: "M316.08,194.61a25.27,25.27,0,0,0,3.81,8.54,24.85,24.85,0,0,1,2.63,4.1,16.27,16.27,0,0,1,.77,2.64,143.86,143.86,0,0,1,3,15.1,73.82,73.82,0,0,1,.05,18.07c3.91-3.78,3.9-10,3.44-15.38q-.9-10.6-2.68-21.11a16.36,16.36,0,0,1-7.32-13.84,1.56,1.56,0,0,0-1.8.45Z",
    className: "fishandtipps_svg__cls-33",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_187",
    d: "M286.75,225.23A35.5,35.5,0,0,0,306.3,242.9a42.19,42.19,0,0,1-13.77,4.27c-.38,3.17-.53,6.9,1.93,8.93,1.93,1.59,4.86,1.41,7.09.26a21.37,21.37,0,0,0,5.62-4.93,6,6,0,0,1,3-2.13c1.83-.4,3.57.89,4.92,2.19a39.64,39.64,0,0,1,11.35,21,15.23,15.23,0,0,0,6,.69,5.2,5.2,0,0,0,4.42-3.63,7.56,7.56,0,0,0-.78-4.26,154,154,0,0,0-9.85-20.11,30,30,0,0,0,5.68-8.19c1.27-3.09,1.49-6.78-.19-9.67s-5.59-4.52-8.58-3a34.18,34.18,0,0,0-.42,14.79c-8.1-7.83-4.43-22-10.21-31.67-3.77-.6-8.59.74-11.14,3.32a30.81,30.81,0,0,0,5.89,20.71c-2.43-1.32-4.16-3.61-5.92-5.74s-2.32-6.87-5-7.65-7.08,1.73-8.78,5.39Z",
    className: "fishandtipps_svg__cls-34",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_188",
    d: "M302.43,214A22.92,22.92,0,0,0,310,228a2.15,2.15,0,0,0,1.55.71c.86-.1,1.26-1.12,1.45-2a32.56,32.56,0,0,0-.24-14.76,8.48,8.48,0,0,1-3.71.38L302.2,214c0,.18.2-.15.22,0Z",
    className: "fishandtipps_svg__cls-35",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_189",
    d: "M297.84,255.82a73.35,73.35,0,0,0,7.31-6.44,4.56,4.56,0,0,0,1.13-1.55,1.59,1.59,0,0,0-.38-1.76,2,2,0,0,0-1.14-.35,13.83,13.83,0,0,0-6.46.92c-1.23.48-2.58,1.56-2.22,2.83.24.86,1.22,1.49,1.12,2.37Z",
    className: "fishandtipps_svg__cls-35",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_190",
    d: "M324.34,227.56a43.15,43.15,0,0,0,.13,10.47,5.9,5.9,0,0,0,1.65,3.89,6.6,6.6,0,0,0,2.06-1.77,11.29,11.29,0,0,0,1.34-2.43,40.64,40.64,0,0,0,1.48-3.9,5.66,5.66,0,0,0,.35-3,2.13,2.13,0,0,0-2.21-1.73Z",
    className: "fishandtipps_svg__cls-35",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_191",
    d: "M310.57,213.94c2.22,5.64,1,12.1,2.72,17.91,2.4,8.07,10,13.51,13.6,21.12,2,4.24,2.7,9,4.56,13.29a4.35,4.35,0,0,0,1.94,2.43c1,.43,2.4-.14,2.4-1.2a2.35,2.35,0,0,0-.27-1q-4.54-10.36-9.1-20.72a2.88,2.88,0,0,1-.34-1.25,3.09,3.09,0,0,1,.6-1.46,38.69,38.69,0,0,0,4.12-8.93,5.16,5.16,0,0,0,.28-2.91,2,2,0,0,0-2.21-1.49,15.89,15.89,0,0,1-3,9.84c-.68.94-1.74,1.9-2.86,1.57a2.83,2.83,0,0,1-1.07-.71c-3.56-3.3-5.28-8.13-6.21-12.9s-1.22-9.65-2.54-14.32c-.16-.56-.88-1.19-1.14-.68Z",
    className: "fishandtipps_svg__cls-36",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_192",
    d: "M289.68,225.62a15.36,15.36,0,0,0,7.49,9.83,6.75,6.75,0,0,0,5,.94,2.14,2.14,0,0,0,1-.53,2.77,2.77,0,0,0,.38-2.43,23.14,23.14,0,0,0-4.33-9.9,3.54,3.54,0,0,0-2.52-1.7,3.78,3.78,0,0,0-1.8.63l-3.22,1.79Z",
    className: "fishandtipps_svg__cls-35",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_193",
    d: "M289.5,225.78a25.91,25.91,0,0,0,10.09,11.95c3.57,2.25,7.88,3.79,10.13,7.36-3.43,3.24-7.09,6.61-11.69,7.65q.18,1.41.36,2.79c2.32-.15,4.21-1.86,5.89-3.48l3.73-3.6a3.2,3.2,0,0,1,1.33-.91,2.9,2.9,0,0,1,1.21,0,14.45,14.45,0,0,1,8.84,6,38,38,0,0,1,4.75,9.8c.93,2.59,1.81,5.19,2.65,7.82a12.31,12.31,0,0,0,3.35-.62A1.58,1.58,0,0,0,331,270a1.72,1.72,0,0,0-.05-1.62c-2.18-5.68-4.37-11.41-7.63-16.56s-7.68-9.73-13.26-12.16c-2-.89-4.17-1.48-6.17-2.41a20,20,0,0,1-10.73-12.86l-.93.17Z",
    className: "fishandtipps_svg__cls-36",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_194",
    d: "M381.29,243.64a3.86,3.86,0,0,0-1.08-2,3.57,3.57,0,0,0-2.49-.51,21.85,21.85,0,0,0-14,6.33,29.13,29.13,0,0,1,7.9-10.83c3.12-2.66,7.12-5.17,7.64-9.24.43-3.33.28-7.95-3.72-9.06a22.65,22.65,0,0,0-9.69,5.88,32,32,0,0,0,7.52-21.39A29.69,29.69,0,0,0,356,198.91a2.58,2.58,0,0,0-2.77,2.25,30,30,0,0,0,.54,19.3c-2.71-2.72-6.3-4.78-10.14-4.85s-7.84,2.21-9,5.87a3.92,3.92,0,0,0,0,2.66c.54,1.28,2,1.91,3.3,2.28,4.6,1.3,9,2.74,13.35.85-1.24,1.17,1.41-1.91.17-.73-1.29,5.24-.62,7.92-1.92,10.53q-1.45,7.34-3.49,14.55a18.9,18.9,0,0,0-6-12.15,19.64,19.64,0,0,0-6.55,3.57c-1.82,1.72-2.95,4.41-2.13,6.77a8.28,8.28,0,0,0,2.13,3,24.37,24.37,0,0,0,7.57,5.07q-1.95,8.33-3.88,16.65a10.33,10.33,0,0,0-.4,4.1,3.56,3.56,0,0,0,2.54,3l3.5-.95,17.74-21.41a5.28,5.28,0,0,1,1.74-1.55,5.72,5.72,0,0,1,2.39-.28,33.19,33.19,0,0,0,13.45-2.62,8.29,8.29,0,0,0,2.59-1.57c2.41-2.36,1.59-6.35.6-9.58Z",
    className: "fishandtipps_svg__cls-34",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_195",
    d: "M333.41,248.61c1.94,3,5,5.73,8.53,5.58a1.93,1.93,0,0,0,.7-.13c1-.42.94-1.83.65-2.87a23.41,23.41,0,0,0-3.37-7.1c-.39-.2-.81.16-1.1.5l-5.4,4Z",
    className: "fishandtipps_svg__cls-35",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_196",
    d: "M338.29,223.63c.39,1.19,1.84,1.62,3.09,1.79a15.83,15.83,0,0,0,9.35-1.2,2.12,2.12,0,0,0,.76-.57c.73-.92-.09-2.25-1-3a9.38,9.38,0,0,0-4.32-2.39,5,5,0,0,0-4.61,1.27c-.88.93-1.37,2.32-2.55,2.8l-.76,1.34Z",
    className: "fishandtipps_svg__cls-35",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_197",
    d: "M339.54,223.29c4.9,1.39,8.36,2.86,13.42,2.33.52,11.43-1.84,16-6.6,28-3.14-3.95-2.53-5.61-6.28-9.2l-1.92,2c2.8,3.32,5.75,7.08,5.55,11.42a17.76,17.76,0,0,1-.74,3.76q-1.47,5.39-3,10.76a54.55,54.55,0,0,0,16.28-50.18A19.72,19.72,0,0,1,340.19,221l-.58,2.33C339.7,223.45,339.41,223.25,339.54,223.29Z",
    className: "fishandtipps_svg__cls-36",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_198",
    d: "M356,203.22A25,25,0,0,0,357.14,219c.64,1.52,1.77,3.18,3.42,3.16A4,4,0,0,0,363,221c3.65-3,5.56-7.7,6.49-12.35a5,5,0,0,0,0-2.69,3.58,3.58,0,0,0-2.35-2,10.66,10.66,0,0,0-3.18-.33Z",
    className: "fishandtipps_svg__cls-35",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_199",
    d: "M371.62,222.28a16.93,16.93,0,0,0-6,5.55,6.72,6.72,0,0,0-1.33,3.83,3.1,3.1,0,0,0,2.35,3,3.92,3.92,0,0,0,2.25-.47,17.59,17.59,0,0,0,4.94-3.66,5.4,5.4,0,0,0,1.55-2.29,2.11,2.11,0,0,0-.89-2.42Z",
    className: "fishandtipps_svg__cls-35",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_200",
    d: "M366.91,205.7a56.79,56.79,0,0,1-4.84,12.85,9.22,9.22,0,0,0-1.42,4,16.75,16.75,0,0,0,.84,3.85c.59,2.58,0,5.26-.55,7.84a29,29,0,0,1,10.8-8.93c.74-.64,0-2-.94-2.15a4,4,0,0,0-2.71,1l-4.49,3a93.34,93.34,0,0,0,5.86-21.19l-1.34-.31Z",
    className: "fishandtipps_svg__cls-36",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_201",
    d: "M378.21,243.61a10.26,10.26,0,0,0-10.07,3.23,3.16,3.16,0,0,0-.93,3,3,3,0,0,0,1,1.24,8.83,8.83,0,0,0,4,1.9,12.78,12.78,0,0,0,6.76-1.38V249.5l-.78-5.9Z",
    className: "fishandtipps_svg__cls-35",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_202",
    d: "M376.53,247.88a58.35,58.35,0,0,1-16.69,1.94q-8.8,12.84-18.61,25l3.09,3.6q7.23-10.53,14.44-21.07a5.09,5.09,0,0,1,4.92-2.78l9.47-.86c1.56-.15,3.26-.35,4.35-1.47s.9-3.47-.63-3.8Z",
    className: "fishandtipps_svg__cls-36",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_203",
    d: "M311.49,298c-.15-1.81-.25-2.86-.3-4.55-.2-7.21,2.07-14.65,7.05-19.87S331,265.7,338,267.73c9.24,2.71,14.53,12.4,17.24,21.64,1.14,3.88,1.87,8.47-.66,11.62a11.47,11.47,0,0,1-3.83,2.83,36.4,36.4,0,0,1-39-4.42Z",
    className: "fishandtipps_svg__cls-24",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_204",
    d: "M355.22,289.37c-2.62-8.91-7.64-18.21-16.27-21.3a22.41,22.41,0,0,1-4.25,14.11c-3.17,4.6-7.55,8.23-12.05,11.55a25,25,0,0,1-7.22,4.07,11.2,11.2,0,0,1-3.9.5l.16,1.1a36.38,36.38,0,0,0,39,4.42,11.31,11.31,0,0,0,3.82-2.82C357.08,297.84,356.35,293.25,355.22,289.37Z",
    className: "fishandtipps_svg__cls-25",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_205",
    d: "M338,267.73c-6.92-2-14.75.63-19.73,5.85s-7.25,12.66-7.05,19.87c.05,1.69.15,2.74.3,4.55l.2,1.4c.31.26.63.49.95.73.45-5.39,1.16-10.83,3.64-15.6A22.7,22.7,0,0,1,349,276a21.14,21.14,0,0,0-11-8.26Z",
    className: "fishandtipps_svg__cls-26",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_206",
    d: "M334.37,275.62c-.88,1.4-2.37,2.05-3.35,1.44s-1-2.24-.18-3.64,2.37-2.05,3.34-1.44S335.24,274.23,334.37,275.62Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_207",
    d: "M328.21,285.32c-.68,1.48-1.86,2.38-2.63,2s-.84-1.84-.16-3.31,1.85-2.38,2.62-2S328.89,283.85,328.21,285.32Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_208",
    d: "M334.59,294.35c.21,1.12-.8,2.25-2.25,2.53s-2.8-.4-3-1.53.8-2.24,2.25-2.52S334.39,293.23,334.59,294.35Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_209",
    d: "M321.63,295.17a1.76,1.76,0,1,1-1.56-2,1.77,1.77,0,0,1,1.56,2Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_210",
    d: "M350.14,283.54a2.82,2.82,0,1,1-2.88-2.76l.36,0A2.64,2.64,0,0,1,350.14,283.54Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_211",
    d: "M334.7,276.29c-.86,1.36-2.31,2-3.27,1.39s-1-2.18-.18-3.54,2.31-2,3.26-1.39S335.55,274.93,334.7,276.29Z",
    className: "fishandtipps_svg__cls-28",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_212",
    d: "M338.33,282.49Z",
    className: "fishandtipps_svg__cls-9",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_213",
    d: "M328.69,285.72c-.66,1.43-1.81,2.3-2.56,1.95s-.83-1.78-.16-3.22,1.81-2.3,2.56-1.95S329.35,284.28,328.69,285.72Z",
    className: "fishandtipps_svg__cls-28",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_214",
    d: "M334.92,294.49c.21,1.09-.77,2.19-2.19,2.46s-2.74-.4-2.94-1.49.78-2.18,2.2-2.45A2.37,2.37,0,0,1,334.92,294.49Z",
    className: "fishandtipps_svg__cls-29",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_215",
    d: "M322.28,295.29a1.72,1.72,0,1,1-1.53-1.93,1.75,1.75,0,0,1,1.53,1.93Z",
    className: "fishandtipps_svg__cls-29",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_216",
    d: "M350.1,284a2.76,2.76,0,1,1-2.83-2.68,2.17,2.17,0,0,1,.36,0A2.58,2.58,0,0,1,350.1,284Z",
    className: "fishandtipps_svg__cls-29",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_217",
    d: "M322.22,276.6c-1.78,2.15-3.8,3.4-4.54,2.79s.11-2.83,1.88-5,3.8-3.4,4.54-2.79-.11,2.83-1.88,5Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_218",
    d: "M316.91,282.44a1,1,0,1,1-.9-1.3,1.12,1.12,0,0,1,.9,1.3Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_219",
    d: "M313.63,211.8c.5,2-1.67,4.25-4.83,5s-6.13-.2-6.63-2.2,1.67-4.25,4.84-5S313.14,209.8,313.63,211.8Z",
    className: "fishandtipps_svg__cls-37",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_220",
    d: "M313.12,211.43c.39,1.59-1.63,3.46-4.52,4.17s-5.54,0-5.93-1.59,1.62-3.45,4.51-4.17S312.72,209.84,313.12,211.43Z",
    className: "fishandtipps_svg__cls-38",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_221",
    d: "M323.19,186.64c1.58,1.31,1.19,4.41-.88,6.93s-5,3.5-6.63,2.19-1.2-4.41.88-6.93S321.6,185.34,323.19,186.64Z",
    className: "fishandtipps_svg__cls-37",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_222",
    d: "M322.55,186.66c1.26,1,.76,3.74-1.13,6S317,196,315.71,195s-.76-3.75,1.13-6S321.28,185.62,322.55,186.66Z",
    className: "fishandtipps_svg__cls-38",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_223",
    d: "M332.18,231.22c-.74,1.41-3.15,1.6-5.38.44s-3.45-3.26-2.72-4.67,3.14-1.61,5.38-.44S332.91,229.81,332.18,231.22Z",
    className: "fishandtipps_svg__cls-37",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_224",
    d: "M332.07,230.73c-.59,1.13-2.72,1.18-4.76.11s-3.21-2.83-2.62-4,2.71-1.17,4.75-.1S332.65,229.61,332.07,230.73Z",
    className: "fishandtipps_svg__cls-38",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_225",
    d: "M340.73,243.92c.88,1.33-.12,3.53-2.23,4.92s-4.52,1.43-5.4.1.13-3.53,2.23-4.91S339.86,242.59,340.73,243.92Z",
    className: "fishandtipps_svg__cls-37",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_226",
    d: "M340.26,243.79c.7,1.05-.3,2.94-2.22,4.2s-4,1.43-4.74.37.3-2.94,2.22-4.2S339.56,242.73,340.26,243.79Z",
    className: "fishandtipps_svg__cls-38",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_227",
    d: "M344.29,217.9c.88,1.33-.12,3.53-2.23,4.91s-4.52,1.43-5.4.11.13-3.53,2.23-4.92S343.42,216.57,344.29,217.9Z",
    className: "fishandtipps_svg__cls-37",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_228",
    d: "M343.82,217.77c.7,1-.3,2.93-2.22,4.2s-4,1.43-4.74.37.3-2.94,2.22-4.21S343.12,216.71,343.82,217.77Z",
    className: "fishandtipps_svg__cls-38",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_229",
    d: "M370.17,205.52c-.32,2.09-3.73,3.3-7.61,2.7s-6.78-2.78-6.45-4.87,3.73-3.3,7.61-2.7S370.49,203.43,370.17,205.52Z",
    className: "fishandtipps_svg__cls-37",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_230",
    d: "M369.76,205c-.26,1.66-3.34,2.57-6.88,2s-6.2-2.33-5.95-4,3.33-2.57,6.88-2S370,203.28,369.76,205Z",
    className: "fishandtipps_svg__cls-38",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_231",
    d: "M351.41,172.1c-.1,2.12-4.31,3.62-9.4,3.35s-9.11-2.18-9-4.3,4.32-3.61,9.4-3.35S351.52,170,351.41,172.1Z",
    className: "fishandtipps_svg__cls-37",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_232",
    d: "M350.79,171.57c-.09,1.69-3.91,2.85-8.55,2.62s-8.32-1.8-8.23-3.48,3.91-2.85,8.55-2.62S350.88,169.89,350.79,171.57Z",
    className: "fishandtipps_svg__cls-38",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_233",
    d: "M377.11,228.71c-1.28,1.11-3.64.48-5.3-1.41s-2-4.32-.69-5.43,3.64-.48,5.29,1.4,2,4.32.7,5.44Z",
    className: "fishandtipps_svg__cls-37",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_234",
    d: "M377.19,228.21c-1,.88-3.05.2-4.56-1.52s-1.9-3.83-.89-4.71,3.05-.21,4.56,1.51S378.2,227.32,377.19,228.21Z",
    className: "fishandtipps_svg__cls-38",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_235",
    d: "M378.92,252.16c-1.63.46-3.49-1.13-4.17-3.54s.09-4.75,1.72-5.2,3.49,1.13,4.16,3.54S380.54,251.71,378.92,252.16Z",
    className: "fishandtipps_svg__cls-37",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_236",
    d: "M379.21,251.75c-1.3.36-2.84-1.13-3.46-3.33s-.06-4.28,1.23-4.65,2.84,1.13,3.46,3.34S380.51,251.39,379.21,251.75Z",
    className: "fishandtipps_svg__cls-38",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_237",
    d: "M298,220.7c1.12,1.53,0,4.21-2.4,6s-5.31,2-6.42.4,0-4.21,2.4-6,5.32-1.95,6.43-.4Z",
    className: "fishandtipps_svg__cls-37",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_238",
    d: "M297.43,220.56c.89,1.22-.2,3.52-2.42,5.13s-4.74,1.91-5.62.69.2-3.52,2.42-5.13,4.74-1.92,5.62-.69Z",
    className: "fishandtipps_svg__cls-38",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_239",
    d: "M295.16,248.16c1.38-.42,3,1,3.7,3.2s.08,4.29-1.3,4.71-3-1-3.7-3.2-.08-4.3,1.3-4.71Z",
    className: "fishandtipps_svg__cls-37",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_240",
    d: "M294.92,248.54c1.1-.34,2.48,1,3.08,3s.2,3.88-.89,4.22-2.48-1-3.09-3-.2-3.88.9-4.21Z",
    className: "fishandtipps_svg__cls-38",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_241",
    d: "M356.34,222.58c1.58,7.35,2.26,15,.9,22.4s-4.85,14.56-10.59,19.41a46,46,0,0,0,7.55-17.89,122.14,122.14,0,0,0,2.07-19.45Z",
    className: "fishandtipps_svg__cls-35",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_242",
    d: "M311.11,227.88c3.92,11.71,12.7,21.13,18.18,32.2-2.2-12.47-13.18-21.51-17.71-33.35Z",
    className: "fishandtipps_svg__cls-35",
    transform: "translate(-35.75 -38.86)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "fishandtipps_svg__slice1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1243",
    d: "M1565.43,184.85a4.89,4.89,0,1,1-4.89-4.89A4.88,4.88,0,0,1,1565.43,184.85Z",
    className: "fishandtipps_svg__cls-39",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1244",
    d: "M1564.69,184.85a4.15,4.15,0,1,1-4.15-4.15,4.14,4.14,0,0,1,4.15,4.15Z",
    className: "fishandtipps_svg__cls-40",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1245",
    d: "M1561.62,182.8a1.65,1.65,0,1,1-1.84-1.45h.2A1.55,1.55,0,0,1,1561.62,182.8Z",
    className: "fishandtipps_svg__cls-41",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1246",
    d: "M1558.84,185.28a.69.69,0,0,1-.67.69.68.68,0,0,1-.68-.67.66.66,0,0,1,.66-.68h0a.67.67,0,0,1,.68.66Z",
    className: "fishandtipps_svg__cls-41",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1247",
    d: "M1546.67,282.71a3.4,3.4,0,1,1-3.4-3.4h0A3.4,3.4,0,0,1,1546.67,282.71Z",
    className: "fishandtipps_svg__cls-39",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1248",
    d: "M1546.16,282.71a2.89,2.89,0,1,1-2.89-2.88h0a2.89,2.89,0,0,1,2.89,2.88Z",
    className: "fishandtipps_svg__cls-40",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1249",
    d: "M1544,281.29a1.15,1.15,0,1,1-2.29.27,1.16,1.16,0,0,1,1-1.28h.14A1.09,1.09,0,0,1,1544,281.29Z",
    className: "fishandtipps_svg__cls-41",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1250",
    d: "M1542.08,283a.47.47,0,0,1-.46.48.47.47,0,1,1,0-.94h0A.45.45,0,0,1,1542.08,283Z",
    className: "fishandtipps_svg__cls-41",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1251",
    d: "M1641.54,256.76a5.81,5.81,0,1,1-5.81-5.81,5.8,5.8,0,0,1,5.81,5.81Z",
    className: "fishandtipps_svg__cls-39",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1252",
    d: "M1640.67,256.76a4.94,4.94,0,1,1-4.94-4.93,4.94,4.94,0,0,1,4.94,4.93Z",
    className: "fishandtipps_svg__cls-40",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1253",
    d: "M1637,254.33a2,2,0,1,1-2.2-1.72l.24,0A1.87,1.87,0,0,1,1637,254.33Z",
    className: "fishandtipps_svg__cls-41",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1254",
    d: "M1633.7,257.27a.81.81,0,0,1-.79.82.8.8,0,0,1,0-1.6h0a.79.79,0,0,1,.8.78Z",
    className: "fishandtipps_svg__cls-41",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1255",
    d: "M1645.64,278.76a3.48,3.48,0,1,1-3.48-3.48A3.48,3.48,0,0,1,1645.64,278.76Z",
    className: "fishandtipps_svg__cls-39",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1256",
    d: "M1645.11,278.76a3,3,0,1,1-2.95-3,2.95,2.95,0,0,1,2.95,3Z",
    className: "fishandtipps_svg__cls-40",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1257",
    d: "M1642.93,277.3a1.18,1.18,0,1,1-1.31-1h.13A1.12,1.12,0,0,1,1642.93,277.3Z",
    className: "fishandtipps_svg__cls-41",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1258",
    d: "M1640.94,279.06a.47.47,0,0,1-.47.49.48.48,0,0,1-.49-.47.49.49,0,0,1,.47-.49h0a.47.47,0,0,1,.48.47Z",
    className: "fishandtipps_svg__cls-41",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1259",
    d: "M1607.69,213.22c0-6.51-1.73-12.9-2.08-19.4s1-13.63,5.87-17.93l1.19,1c.09-.91.19-1.82.29-2.73.76.38,1.34-.75,1.64-1.55,1.65-4.58,8.43-5.47,10.28-10q-1.74,6.59-4,13c.61.81-.2,1.91-1,2.58a24.9,24.9,0,0,1-2.06,10.46c-.66,1.51-1.82,3.17-3.47,3.05a2.62,2.62,0,0,0,1.29,1.1,37.52,37.52,0,0,1-7,20.61l-1-.26Z",
    className: "fishandtipps_svg__cls-19",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1260",
    d: "M1622.67,165.52c-2.77,2.33-6.85,3.7-8.08,7.11-.29.8-.87,1.93-1.63,1.54-.1.91-.2,1.82-.29,2.73l-1.19-1c-4.89,4.3-6.23,11.43-5.87,17.93.26,4.9,1.31,9.74,1.81,14.61a2.87,2.87,0,0,0,1.69.94l.69-.49a67.65,67.65,0,0,1,12.87-43.36Z",
    className: "fishandtipps_svg__cls-20",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1261",
    d: "M1624.87,162.67h0Z",
    className: "fishandtipps_svg__cls-20",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1262",
    d: "M1614.65,196.53a34.58,34.58,0,0,1-1.32,7.42c.05.15.09.3.13.46a37.24,37.24,0,0,0,2.21-11.53,2.6,2.6,0,0,1-1.28-1.1c1.64.11,2.81-1.55,3.46-3.06a24.86,24.86,0,0,0,2.07-10.45c.76-.68,1.57-1.78,1-2.59q2.26-6.42,4-13a6.8,6.8,0,0,1-1.13,1.81q-1.93,6-4.2,11.82l.57.86c-.74.65-.72,1.79-.73,2.78a15.78,15.78,0,0,1-5.6,11.78,7.69,7.69,0,0,1,.86,4.84Z",
    className: "fishandtipps_svg__cls-16",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1263",
    d: "M1623,165.08a49.53,49.53,0,0,0-13.62,39.54,94,94,0,0,1,7.28-29.08,30.76,30.76,0,0,1,5.48-9.13Z",
    className: "fishandtipps_svg__cls-23",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1264",
    d: "M1607.88,213.56c-1.3-7.53-8.29-13-10-20.44-1.18-5.17.38-10.58,2.61-15.38s5.17-9.28,7-14.25l.66,9c0,.62.87,1.38,1,.78l-3.27,4.29,1.53.6a15,15,0,0,0-2.23,9.63c.17,1.52.55,3.17-.25,4.47a74.42,74.42,0,0,1,3.54,20.87Z",
    className: "fishandtipps_svg__cls-17",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1265",
    d: "M1607.66,212.53a2.72,2.72,0,0,0,.8-1.12h0l-.21.4c-1.85-6.41-6-12-7.61-18.48a24.47,24.47,0,0,1,1.26-15.25c1.18-2.74,2.84-5.24,4.08-7.94a17,17,0,0,0,1.6-5.68c0-.32,0-.64-.07-1-1.84,5-4.77,9.45-7,14.25s-3.79,10.21-2.61,15.38C1599.51,200.22,1606,205.53,1607.66,212.53Z",
    className: "fishandtipps_svg__cls-18",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1266",
    d: "M1605.25,187.77a15,15,0,0,1,2.23-9.63l-1.53-.59,3.13-4.11c-.29.16-.87-.45-.91-1l-.66-9c-1.84,5-4.77,9.45-7,14.25s-3.79,10.21-2.61,15.38a17.75,17.75,0,0,0,.65,2.15c-.11-.44-.21-.89-.3-1.34a18.47,18.47,0,0,1,.76-11,47.42,47.42,0,0,1,3.2-5.52,54.26,54.26,0,0,0,4.72-11.45,20.92,20.92,0,0,0,.69,7.63,41.47,41.47,0,0,0-2.65,5.13,1.88,1.88,0,0,0,1.06.43,15.41,15.41,0,0,0-1.53,10.89,3.16,3.16,0,0,1,.13,1.18c0,.26-.17.49-.22.74-.28,1.33,1.2,2.38,1.46,3.7,0-.24,0-.47,0-.71-.26-.9-.52-1.81-.81-2.7C1605.8,190.94,1605.42,189.29,1605.25,187.77Z",
    className: "fishandtipps_svg__cls-16",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1267",
    d: "M1609.22,173.25l-.14.18A.28.28,0,0,0,1609.22,173.25Z",
    className: "fishandtipps_svg__cls-16",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1268",
    d: "M1604.23,173.57a27.59,27.59,0,0,0-1.4,25.44c-4.71-6.63-4.42-16-.42-23.11Z",
    className: "fishandtipps_svg__cls-23",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1269",
    d: "M1608.29,206.49c-.81-4.48-2.79-8.67-3.84-13.1s-1-9.49,1.82-13l.94.55c0-.64-.09-1.28-.13-1.91.57.16.83-.68.93-1.27.57-3.35,5.12-4.81,5.83-8.13-.25,3.16-.62,6.32-1.13,9.46.52.48.1,1.33-.34,1.89a17.5,17.5,0,0,1-.12,7.45c-.27,1.12-.87,2.4-2,2.53a1.78,1.78,0,0,0,1,.59,26.23,26.23,0,0,1-2.23,15Z",
    className: "fishandtipps_svg__cls-19",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1270",
    d: "M1612.68,171.82c-1.61,2-4.25,3.39-4.67,5.89-.1.59-.36,1.43-.93,1.27,0,.63.09,1.27.13,1.91l-.94-.55c-2.83,3.56-2.87,8.63-1.82,13.06.79,3.33,2.11,6.53,3.06,9.82a2,2,0,0,0,1.28.44l.41-.42a47.34,47.34,0,0,1,3.48-31.42Z",
    className: "fishandtipps_svg__cls-20",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1271",
    d: "M1613.84,169.58Z",
    className: "fishandtipps_svg__cls-20",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1272",
    d: "M1611,194.14a24.43,24.43,0,0,1,0,5.27c0,.1.1.2.14.3a26,26,0,0,0,.1-8.21,1.83,1.83,0,0,1-1-.59c1.14-.13,1.74-1.41,2-2.53a17.5,17.5,0,0,0,.12-7.45c.44-.56.86-1.42.34-1.9.51-3.13.88-6.29,1.13-9.46a4.39,4.39,0,0,1-.55,1.39q-.58,4.35-1.42,8.65l.5.52a2.5,2.5,0,0,0-.16,2,11.1,11.1,0,0,1-2.39,8.8A5.44,5.44,0,0,1,1611,194.14Z",
    className: "fishandtipps_svg__cls-16",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1273",
    d: "M1612.88,171.47a34.61,34.61,0,0,0-4.47,28.88,65.88,65.88,0,0,1,1.4-20.9,21.48,21.48,0,0,1,2.65-7l.42-1Z",
    className: "fishandtipps_svg__cls-23",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1274",
    d: "M1605.86,220.15c.26-6.34,5.85-11,11.19-14.45s11.33-7,13.3-13c1.17-3.6.68-7.53-.32-11.18-.73-2.69-1.72-5.63-.55-8.17a14.89,14.89,0,0,0-2.68,14.89L1626,188a9.62,9.62,0,0,1-2.45,4,3.49,3.49,0,0,1,1.73,1.44,4.25,4.25,0,0,1-2.2.32l-4.72,4.69c-5.85,5.83-12.09,12.46-12.48,20.7l0,1Z",
    className: "fishandtipps_svg__cls-14",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1275",
    d: "M1628,175.4a15,15,0,0,0-1.16,12.8L1626,188a9.62,9.62,0,0,1-2.45,4,3.49,3.49,0,0,1,1.73,1.44,4.25,4.25,0,0,1-2.2.32l-4.72,4.69a62.65,62.65,0,0,0-8.88,10.36l.06.17.14,1.27c2.46-4.34,6.28-7.75,10.33-10.66,2.94-2.11,6.18-4.19,7.66-7.48s.88-7.19.45-10.83a23.3,23.3,0,0,1-.11-5.9Z",
    className: "fishandtipps_svg__cls-15",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1276",
    d: "M1627.68,188.19a6.84,6.84,0,0,1-1.33-4.11,17.34,17.34,0,0,1,1.54-8c0-.23,0-.46.07-.68a15,15,0,0,0-1.16,12.8L1626,188a9.72,9.72,0,0,1-2.45,4.05,3.47,3.47,0,0,1,1.73,1.43,4.05,4.05,0,0,1-2.2.32l-4.72,4.69c-1.08,1.09-2.18,2.19-3.25,3.33a.69.69,0,0,1,0,.1,56.1,56.1,0,0,0,7.57-6.62,1.91,1.91,0,0,1,.69-.54,3.76,3.76,0,0,1,.82-.11,2.12,2.12,0,0,0,1.77-1.66,2.37,2.37,0,0,0-1.39-1.38,5.61,5.61,0,0,0,1.4-1.94,2.47,2.47,0,0,1,1.8-1.45Z",
    className: "fishandtipps_svg__cls-16",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1277",
    d: "M1628,178.68a31,31,0,0,1,.82,10,13,13,0,0,1-4.42,8.73,26.52,26.52,0,0,1-2.71,1.8,65.64,65.64,0,0,0-9.2,7.5c1.6-3.3,4.73-5.53,7.68-7.71s6-4.61,7.25-8.05c1.36-3.69.4-7.78.44-11.71l.15-.52Z",
    className: "fishandtipps_svg__cls-19",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1278",
    d: "M1601.13,217.18c.27-6.34,5.86-11,11.2-14.46s11.33-7,13.3-13c1.17-3.6.68-7.54-.32-11.18-.73-2.7-1.73-5.64-.56-8.17a14.91,14.91,0,0,0-2.67,14.89l-.84-.23a9.82,9.82,0,0,1-2.45,4,3.45,3.45,0,0,1,1.72,1.43,4.05,4.05,0,0,1-2.2.32l-4.71,4.7c-5.86,5.82-12.09,12.45-12.48,20.7Z",
    className: "fishandtipps_svg__cls-14",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1279",
    d: "M1623.24,172.43a15,15,0,0,0-1.16,12.79l-.84-.23a9.72,9.72,0,0,1-2.45,4,3.42,3.42,0,0,1,1.73,1.43,4.07,4.07,0,0,1-2.2.32l-4.72,4.7a62.58,62.58,0,0,0-8.88,10.35.64.64,0,0,0,.06.18l.14,1.26c2.46-4.34,6.28-7.74,10.33-10.65,2.94-2.11,6.17-4.19,7.66-7.48s.88-7.19.44-10.83a23.77,23.77,0,0,1-.1-5.9Z",
    className: "fishandtipps_svg__cls-19",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1280",
    d: "M1623,185.21a6.81,6.81,0,0,1-1.32-4.11,17.22,17.22,0,0,1,1.53-8c0-.22,0-.45.08-.67a15,15,0,0,0-1.16,12.79l-.84-.23a9.84,9.84,0,0,1-2.46,4,3.42,3.42,0,0,1,1.73,1.43,4.05,4.05,0,0,1-2.2.32l-4.71,4.7c-1.09,1.08-2.18,2.18-3.25,3.32l0,.1a54.82,54.82,0,0,0,7.57-6.62,2.12,2.12,0,0,1,.69-.54,4.6,4.6,0,0,1,.83-.11,2.09,2.09,0,0,0,1.76-1.65,2.36,2.36,0,0,0-1.39-1.39,5.58,5.58,0,0,0,1.39-1.94,2.55,2.55,0,0,1,1.8-1.45Z",
    className: "fishandtipps_svg__cls-16",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1281",
    d: "M1623.28,175.71a31.22,31.22,0,0,1,.81,10,13.07,13.07,0,0,1-4.41,8.74,30.61,30.61,0,0,1-2.73,1.8,66.22,66.22,0,0,0-9.2,7.5c1.6-3.3,4.73-5.53,7.69-7.71s6-4.61,7.25-8.05c1.35-3.69.4-7.78.43-11.72Z",
    className: "fishandtipps_svg__cls-23",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1282",
    d: "M1598.37,285.49a221.39,221.39,0,0,1,5.9-58.1c.21-.86.63-1.9,1.51-1.95s2,1.29,2.76.63a155.19,155.19,0,0,0-5.94,52.71c.16,2.63-.27,6.15-2.87,6.57l-1.36.13Z",
    className: "fishandtipps_svg__cls-42",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1283",
    d: "M1623.41,217.75a18.66,18.66,0,0,0-2.65-16.68,43.57,43.57,0,0,1-19.71-2.23,19.57,19.57,0,0,0-7,10.18c-2.81,9.46,1.47,19.09,9.57,21.5S1620.6,227.21,1623.41,217.75Z",
    className: "fishandtipps_svg__cls-42",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1284",
    d: "M1621.24,201.73c-.33,5.4-1.53,10.8-4.7,15.12-3.81,5.18-11.08,8.24-16.93,5.56a12.9,12.9,0,0,1-6.38-7c.2,7.06,4.17,13.21,10.42,15.07,8.1,2.41,16.94-3.31,19.76-12.77a18.82,18.82,0,0,0-2.18-16Z",
    className: "fishandtipps_svg__cls-43",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1285",
    d: "M1623.41,217.75a18.66,18.66,0,0,0-2.65-16.68,43.57,43.57,0,0,1-19.71-2.23,19.57,19.57,0,0,0-7,10.18,20.13,20.13,0,0,0-.48,9.72,21.24,21.24,0,0,1,6.84-16.62,17.91,17.91,0,0,0,20.14,1.94c2.94,4.53,2.88,10.15,2.15,15.62A19.08,19.08,0,0,0,1623.41,217.75Z",
    className: "fishandtipps_svg__cls-44",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1286",
    d: "M1603.4,228.21c1.08,3.14.72,6.57.25,9.85-1.58,10.87-4.43,21.75-3.34,32.67a160.48,160.48,0,0,1,9-43.58l-2.85.29-3.09.77Z",
    className: "fishandtipps_svg__cls-43",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1287",
    d: "M1609.11,202.67c-.19.72-1.69,1-3.36.51s-2.87-1.37-2.68-2.09,1.69-1,3.36-.51S1609.29,202,1609.11,202.67Z",
    className: "fishandtipps_svg__cls-45",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1288",
    d: "M1614.05,203.41c0,.47-.51.85-1.14.85s-1.13-.39-1.13-.86.5-.85,1.13-.85S1614.05,202.94,1614.05,203.41Z",
    className: "fishandtipps_svg__cls-45",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1289",
    d: "M1551.77,295.19c-.24-1.29-.38-2-.55-3.26a20.09,20.09,0,0,1,3.58-14.83c3.18-4.13,8.62-6.63,13.76-5.7,6.85,1.26,11.39,7.83,14,14.28,1.11,2.7,2,5.95.4,8.41a8.2,8.2,0,0,1-2.54,2.33,26.33,26.33,0,0,1-28.43-.25l-.25-1Z",
    className: "fishandtipps_svg__cls-24",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1290",
    d: "M1582.59,285.68c-2.55-6.21-6.86-12.53-13.31-14.1a16.28,16.28,0,0,1-2,10.47,36.35,36.35,0,0,1-7.81,9.22,17.85,17.85,0,0,1-4.88,3.47,8.08,8.08,0,0,1-2.77.66l.19.78a26.33,26.33,0,0,0,28.43.24,8.2,8.2,0,0,0,2.54-2.33c1.59-2.46.71-5.71-.4-8.41Z",
    className: "fishandtipps_svg__cls-25",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1291",
    d: "M1568.56,271.41c-5.14-.94-10.58,1.56-13.76,5.7a20.07,20.07,0,0,0-3.58,14.82c.17,1.22.31,2,.55,3.26l.25,1c.24.16.5.3.74.46-.08-3.92,0-7.88,1.45-11.5a16.9,16.9,0,0,1,13.46-10.37,16.59,16.59,0,0,1,9.41,1.76,15.16,15.16,0,0,0-8.53-5.12Z",
    className: "fishandtipps_svg__cls-26",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1292",
    d: "M1566.55,277.36c-.52,1.08-1.55,1.65-2.3,1.28s-.92-1.53-.4-2.6,1.55-1.65,2.3-1.29S1567.07,276.29,1566.55,277.36Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1293",
    d: "M1562.85,284.8c-.38,1.11-1.15,1.85-1.73,1.66s-.75-1.27-.37-2.38,1.15-1.85,1.74-1.65S1563.23,283.69,1562.85,284.8Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1294",
    d: "M1568.13,290.82a2,2,0,1,1-2.76-.65,1.74,1.74,0,0,1,.48-.22A1.77,1.77,0,0,1,1568.13,290.82Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1295",
    d: "M1558.86,292.39a1.28,1.28,0,1,1-1.27-1.3A1.27,1.27,0,0,1,1558.86,292.39Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1296",
    d: "M1578.5,281.87a2,2,0,1,1-2.28-1.76,1.1,1.1,0,0,1,.26,0A1.9,1.9,0,0,1,1578.5,281.87Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1297",
    d: "M1566.84,277.81c-.51,1.05-1.51,1.61-2.24,1.25s-.91-1.49-.4-2.53,1.51-1.6,2.24-1.25S1567.35,276.77,1566.84,277.81Z",
    className: "fishandtipps_svg__cls-28",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1298",
    d: "M1569.92,282",
    className: "fishandtipps_svg__cls-9",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1299",
    d: "M1563.23,285.05c-.37,1.08-1.13,1.8-1.7,1.6s-.72-1.23-.36-2.31,1.13-1.8,1.7-1.6S1563.6,284,1563.23,285.05Z",
    className: "fishandtipps_svg__cls-28",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1300",
    d: "M1568.38,290.9a2,2,0,1,1-2.7-.63,1.82,1.82,0,0,1,.47-.22A1.72,1.72,0,0,1,1568.38,290.9Z",
    className: "fishandtipps_svg__cls-29",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1301",
    d: "M1559.34,292.42a1.25,1.25,0,1,1-1.25-1.27,1.26,1.26,0,0,1,1.25,1.27Z",
    className: "fishandtipps_svg__cls-29",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1302",
    d: "M1578.5,282.19a2,2,0,1,1-2.23-1.71l.26,0A1.86,1.86,0,0,1,1578.5,282.19Z",
    className: "fishandtipps_svg__cls-29",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1303",
    d: "M1557.88,279c-1.11,1.68-2.48,2.73-3.05,2.35s-.14-2.05,1-3.73,2.49-2.73,3.06-2.35S1559,277.3,1557.88,279Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1304",
    d: "M1554.51,283.58a.76.76,0,0,1-.86.63.75.75,0,0,1,.11-1.5A.82.82,0,0,1,1554.51,283.58Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1305",
    d: "M1586.28,296.64c3.53-6.76,8.18-14.18,14.42-18.57s14.17-6.69,21.64-5.15c9.56,2,17,9.9,21,18.82.8,1.81,1.5,3.8,1.08,5.73-.74,3.35-4.4,5.08-7.71,6-10.37,2.85-21.33,2.46-32.06,1.71-5.5-.38-11.2-.91-16-3.61-1.7-.95-3.63-3-2.55-4.63Z",
    className: "fishandtipps_svg__cls-24",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1306",
    d: "M1624.61,273.52c-1,2.09-.24,5.08-.58,7.57-.62,4.71-5.24,7.67-9.4,10-4.78,2.66-9.64,5.35-15,6.57a21,21,0,0,1-13.36-1h0l-.2.28c-1.08,1.61.85,3.68,2.55,4.63,4.8,2.7,10.5,3.23,16,3.61,10.73.74,21.7,1.14,32.06-1.71,3.3-.91,7-2.63,7.71-6,.43-1.93-.27-3.93-1.08-5.74-3.65-8.2-10.26-15.55-18.73-18.21Z",
    className: "fishandtipps_svg__cls-25",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1307",
    d: "M1622.34,272.92c-7.47-1.54-15.4.76-21.64,5.15s-10.89,11.81-14.42,18.57l-.2.28c-.62.93-.24,2,.52,2.95A28,28,0,0,1,1603,282.82a31.94,31.94,0,0,1,24.79,1c1.35.63,2.82,1.36,4.25,1,.93-.26,1.7-1,2.67-1.11a4.13,4.13,0,0,1,2.72,1,28,28,0,0,1,4.18,3.57c-4.22-7.43-10.93-13.64-19.23-15.35Z",
    className: "fishandtipps_svg__cls-26",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1308",
    d: "M1620.73,289.4c.37,1.46-.8,3.06-2.6,3.57s-3.58-.26-3.94-1.72.8-3.05,2.6-3.57S1620.36,287.94,1620.73,289.4Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1309",
    d: "M1603.47,288.44a3,3,0,1,1-2.85-3.14l.25,0A2.88,2.88,0,0,1,1603.47,288.44Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1310",
    d: "M1615.65,278.41a1.75,1.75,0,1,1-1.65-1.85h.13A1.68,1.68,0,0,1,1615.65,278.41Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1311",
    d: "M1636.38,292.88c-.2,1.5-2,2.5-4,2.23s-3.42-1.7-3.22-3.2,2-2.5,4-2.23S1636.58,291.38,1636.38,292.88Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1312",
    d: "M1618.07,300.27c.15.65-.48,1.37-1.4,1.59s-1.77-.11-1.92-.76.48-1.36,1.4-1.59S1617.93,299.62,1618.07,300.27Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1313",
    d: "M1620.67,289.9c.37,1.4-.78,2.93-2.59,3.42s-3.57-.27-3.95-1.68.78-2.93,2.59-3.42S1620.29,288.49,1620.67,289.9Z",
    className: "fishandtipps_svg__cls-29",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1314",
    d: "M1603.41,288.88a3,3,0,1,1-3-3,2.43,2.43,0,0,1,.38,0A2.83,2.83,0,0,1,1603.41,288.88Z",
    className: "fishandtipps_svg__cls-28",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1315",
    d: "M1615.53,279.29a1.76,1.76,0,1,1-1.72-1.8l.2,0A1.65,1.65,0,0,1,1615.53,279.29Z",
    className: "fishandtipps_svg__cls-28",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1316",
    d: "M1636.32,293.32c-.2,1.45-2,2.4-3.94,2.13s-3.43-1.65-3.23-3.1,1.95-2.4,3.93-2.13S1636.51,291.88,1636.32,293.32Z",
    className: "fishandtipps_svg__cls-29",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1317",
    d: "M1618.06,300.34c.15.63-.47,1.32-1.39,1.53s-1.77-.12-1.92-.74.47-1.32,1.39-1.53S1617.91,299.72,1618.06,300.34Z",
    className: "fishandtipps_svg__cls-29",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1318",
    d: "M1627.86,278.64c-.28,1.15-2.33,1.64-4.58,1.09s-3.84-1.92-3.56-3.08,2.33-1.64,4.58-1.09S1628.15,277.49,1627.86,278.64Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1319",
    d: "M1607.23,279.05a1.37,1.37,0,1,1-1.36-1.56A1.46,1.46,0,0,1,1607.23,279.05Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1320",
    d: "M1595,287.67c-.13-5.23,3.4-9.72,6.52-13.91s6.14-9.29,4.82-14.35c-.89-3.38-3.65-6.25-3.66-9.75,0-3.29,2.45-6.07,5.11-8s5.7-3.44,7.85-5.93,3.11-6.48,1-9l3,.79a7.26,7.26,0,0,1,1.44-6.34c.12.66.26,1.31.38,2a11.5,11.5,0,0,0,.85-13.81,38.6,38.6,0,0,1-3.09-4.13,7.34,7.34,0,0,1,1.93-8.86c-1.24,1.48-.5,3.83.89,5.16s3.27,2,4.86,3.09c5.92,4,6.82,12.68,4.35,19.38s-7.47,12.09-11.66,17.88a11.93,11.93,0,0,0-2.44,4.92c-.48,3,1.15,5.83,2,8.71s.62,6.75-2.14,8a4.37,4.37,0,0,0-3.73-.58c.82.95,1.63,1.91,2.44,2.86a6.93,6.93,0,0,1-3.69,2.64c1.07-.09,1.87,1.11,1.8,2.17a5.67,5.67,0,0,1-1.37,2.86l-16.17,21.83-1-4.27-.38-3.27Z",
    className: "fishandtipps_svg__cls-19",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1321",
    d: "M1625.77,223.66c-1.85,5.6-5.72,10.3-9.94,14.43-2.67,2.62-5.62,5.22-6.83,8.76s-.49,7.33-.29,11a38.64,38.64,0,0,1-5.52,21.9c.81.5,1.7-.5,2.12-1.35a54.37,54.37,0,0,0,4.91-16.58c.61-4.69.63-9.57,2.53-13.89a35.14,35.14,0,0,1,5-7.48c3.75-4.7,7.52-9.58,9.29-15.33,1.57-5.08,1.25-11-1.76-15.31A18.91,18.91,0,0,1,1625.77,223.66Z",
    className: "fishandtipps_svg__cls-14",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1322",
    d: "M1625.86,216.41c-.42-4-2.57-7.66-4-11.44a17,17,0,0,1-1.35-8,7.37,7.37,0,0,0-1.2,8.18,40,40,0,0,0,3.09,4.13,11.5,11.5,0,0,1-.84,13.81l-.39-2a7.29,7.29,0,0,0-1.44,6.34l-3-.79c2.1,2.54,1.14,6.52-1,9s-5.2,4-7.85,5.93-5.12,4.72-5.11,8c0,3.5,2.77,6.37,3.66,9.75,1.32,5.06-1.69,10.16-4.82,14.35a43.15,43.15,0,0,0-5.34,8.34,2.57,2.57,0,0,0,.4.06l2.8,1.55a39.13,39.13,0,0,0,9.83-30.4,15.65,15.65,0,0,1-.18-4.32c.46-2.82,2.64-5,4.57-7.07a59.33,59.33,0,0,0,9.23-13.35C1624.76,224.79,1626.28,220.62,1625.86,216.41Z",
    className: "fishandtipps_svg__cls-14",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1323",
    d: "M1604.3,278.07a10.44,10.44,0,0,0-4.23-2.31,30.84,30.84,0,0,0-4,6.79,9.54,9.54,0,0,0,.33,2.31,23.33,23.33,0,0,0,2.17,6,2.94,2.94,0,0,0,.5.71l8-10.79a16.85,16.85,0,0,0-2.72-2.75Z",
    className: "fishandtipps_svg__cls-14",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1324",
    d: "M1584,290c-.54-6.1-6.83-9.67-11.24-13.91-5.83-5.62-8.74-15.41-3.81-21.83,2.53-3.31,7-5.85,6.9-10-.1-3.88-4.2-6.24-7.74-7.82a4,4,0,0,0,2.17-3.48l2.39,1a3.35,3.35,0,0,1-1.6-2.64c.06-1.07,1.54-1.92,2.25-1.12l-2.17-2.39c2.91-2.1,1.29-6.9-1.48-9.17s-6.49-3.58-8.39-6.63a9.55,9.55,0,0,1,.23-9.62,16.87,16.87,0,0,1,7.59-6.46c-2.43,3.54-4.87,8.34-2.32,11.8,2.31,3.12,7,2.75,10.59,4.32,5.31,2.34,7.46,9.43,5.35,14.85a35.85,35.85,0,0,0-2,5c-1.44,6.45,5.44,12.65,3.89,19.08-.9,3.77-4.48,6.34-5.9,10-1.86,4.75.41,10.06,2.93,14.51s5.42,9.16,4.85,14.24L1584,290Z",
    className: "fishandtipps_svg__cls-20",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1325",
    d: "M1569,266.27a19.54,19.54,0,0,1,1.69-12.58c.71-1.31,1.61-2.54,2.39-3.81-1.37,1.46-3,2.83-4.16,4.38-4.79,6.23-2.18,15.63,3.3,21.32A34.16,34.16,0,0,1,1569,266.27Z",
    className: "fishandtipps_svg__cls-46",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1326",
    d: "M1581.59,275.41c-2.52-4.45-4.79-9.76-2.93-14.51,1.41-3.62,5-6.19,5.9-10,1.55-6.43-5.33-12.63-3.89-19.08a35.8,35.8,0,0,1,2-5c2.12-5.41,0-12.51-5.34-14.85-3.12-1.38-7.12-1.26-9.62-3.31a4.92,4.92,0,0,0,1.43,4.61c1.82,1.68,4.39,2.44,6,4.3,2.44,2.8,1.95,7,1.07,10.65s-2,7.53-.4,10.89c.56,1.2,1.43,2.22,2,3.43,1.76,4.1-.88,8.6-2.67,12.69a24.55,24.55,0,0,0-2,14.38c1,4.83,4.05,9.35,8.56,11.32l0-1.59c.16,1.24,1.65,1.87,2.87,1.59-.89-1.91-2-3.77-3-5.59Z",
    className: "fishandtipps_svg__cls-19",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1327",
    d: "M1575.55,254.59c1.3-3.1,3.19-6.13,3.18-9.5,0-3.71-2.37-7.14-2.25-10.85.07-2,.82-3.83,1.19-5.75a14.94,14.94,0,0,0-7.83-15.72,32.43,32.43,0,0,1-4.4-2.13,6,6,0,0,1-1.21-1.1,7.16,7.16,0,0,1-1-1,14.72,14.72,0,0,0,5.24,5.72c3.06,2.16,6.6,4.29,7.72,7.86,1.35,4.25-1.27,8.74-1.12,13.19.12,3.59,2,7,2,10.56s-2,6.73-3.47,10a22.94,22.94,0,0,0-2,12.88,14.24,14.24,0,0,0,7.31,10.4c-5.92-6.4-6.71-16.48-3.34-24.52Z",
    className: "fishandtipps_svg__cls-14",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1328",
    d: "M1581.58,275.41c-.46-.81-.9-1.65-1.32-2.51a17.63,17.63,0,0,0-6.73,3.92c4.14,3.77,9.45,7.13,10.35,12.43l1.4.28a5.74,5.74,0,0,0,1.17.12C1587,284.57,1584.1,279.85,1581.58,275.41Z",
    className: "fishandtipps_svg__cls-14",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1329",
    d: "M1578.9,269.67a12.66,12.66,0,0,1-.24-8.77c1.41-3.62,5-6.19,5.9-10,1.55-6.43-5.33-12.63-3.89-19.08a35.8,35.8,0,0,1,2-5c2.11-5.41,0-12.51-5.35-14.85-3.55-1.57-8.28-1.2-10.58-4.32-2.55-3.46-.11-8.26,2.31-11.8a16.84,16.84,0,0,0-7.58,6.46,10.21,10.21,0,0,0-1.23,7.11l.64,1.86c.11.22.23.44.36.65a8.39,8.39,0,0,0,1.59,1.87,10.8,10.8,0,0,1-1.15-3.58,11.57,11.57,0,0,1,3.8-10.14c-2.17,2.21-1.46,6.1.6,8.41s5,3.52,7.82,4.89,5.62,3.15,6.81,6c2.15,5.16-2,10.79-1.87,16.37.08,4.49,2.92,8.58,3,13.08.1,4-2,7.75-3.24,11.6-.94,3-1.17,6.57.26,9.18Z",
    className: "fishandtipps_svg__cls-46",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1330",
    d: "M1590.46,306c2.78-5-.64-10.75-4.12-15.42s-7.24-10.17-5.07-15.36,9.49-8.34,9.5-13.7c0-3.35-2.94-6.1-4.89-9a17.16,17.16,0,0,1,1.57-20.92c2.46-2.81,5.82-5.06,7.94-8.05a12.79,12.79,0,0,0-2-16.88c-1.95-1.8-4.41-3.15-6.48-4.85a16.77,16.77,0,0,1-2.69-23.56,14.5,14.5,0,0,1,1-1.18c-2.51,5.12.39,11.65,6.32,14.18,2.48,1.07,5.4,1.51,7.51,3s2.73,4.83.24,5.89l4.26-1.22c-.57,1.44-1.15,2.87-1.72,4.3l3,.7a20.64,20.64,0,0,1,.45,23.28c-3.65,5.59-10.22,10.6-9.57,16.95.68,6.67,9.38,11.65,9,18.34s-10.16,11.65-9.74,18.48c.15,2.32,1.49,4.45,2.3,6.67a15.65,15.65,0,0,1-3.34,15.82l-3.4,2.52Z",
    className: "fishandtipps_svg__cls-19",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1331",
    d: "M1604.77,203.92l-3-.7,1.71-4.3-4.25,1.21c2.48-1.06,1.87-4.37-.24-5.89s-5-2-7.51-3c-5.93-2.54-8.83-9.07-6.32-14.19a16.26,16.26,0,0,0-3.56,5.53c-.75,6,1.71,12.47,6.72,15.95,2.44,1.69,5.36,2.74,7.4,4.9s2.62,5.63.72,7.5c0,0,0,.07,0,.11,2.4-1.08,5.52.57,6.68,3s.76,5.7,0,8.47-1.92,5.51-2,8.4a2.42,2.42,0,0,0,.22,1.21,55.2,55.2,0,0,0,3.8-4.93,20.62,20.62,0,0,0-.46-23.28Z",
    className: "fishandtipps_svg__cls-23",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1332",
    d: "M1587.25,279.65c4.08-5.95,8.36-12.65,7.42-19.81-.68-5.22-4.1-9.83-4.54-15.08-.4-4.9,1.87-9.66,4.75-13.64,1.72-2.37,3.69-4.6,5-7.23a17.06,17.06,0,0,0-.61-16.12c-4.1-6.85-12.76-10.35-15.78-17.73,5.26,6.65,13.85,10.37,18.08,17.72a19.29,19.29,0,0,1,0,18.8c-3.24,5.69-9.56,10.1-9.83,16.64-.22,5.16,3.5,9.58,4.86,14.56,2.25,8.29-2.24,16.76-6.57,24.18a2.44,2.44,0,0,0-2-1.5l-.84-.79Z",
    className: "fishandtipps_svg__cls-14",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1333",
    d: "M1589.85,271.62a26.69,26.69,0,0,0-5.85-.32,13.78,13.78,0,0,0-2.73,3.9c-2.18,5.19,1.58,10.68,5.06,15.36,3.17,4.26,6.3,9.41,4.72,14.07a15.9,15.9,0,0,0,1.67-.33l1.14-.85a15.68,15.68,0,0,0,3.35-15.82c-.81-2.22-2.16-4.35-2.3-6.66-.16-2.48,1-4.7,2.63-6.84A27.52,27.52,0,0,0,1589.85,271.62Z",
    className: "fishandtipps_svg__cls-14",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1334",
    d: "M1613.66,258.78c-2.88,9.41-10.15,16.85-14,25.9a3.47,3.47,0,0,1,1.51.95c4-9.58,8.58-19.32,16.46-26.07a2.56,2.56,0,0,0-1.27-.76Z",
    className: "fishandtipps_svg__cls-42",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1335",
    d: "M1621.4,241.8c-3.31.47-6.29,3.12-8.24,5.85a12.59,12.59,0,0,0-2.45,6,7.65,7.65,0,0,0,2,6.06,6.41,6.41,0,0,0,6.56,1.52,8.21,8.21,0,0,0,4.42-4.27,19.1,19.1,0,0,0,1.5-6.09,57.5,57.5,0,0,0,.33-6.16,3.32,3.32,0,0,0-.5-2.1c-.66-.83-1.9-.85-3-.8Z",
    className: "fishandtipps_svg__cls-42",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1336",
    d: "M1623.64,257a19.22,19.22,0,0,0,1.5-6.1c.16-1.46.26-2.94.3-4.42-.4.84-.81,1.68-1.23,2.5a15.57,15.57,0,0,1-4.12,5.36,7.17,7.17,0,0,1-6.4,1.37,3.9,3.9,0,0,1-1.6-1A4.64,4.64,0,0,1,1611,252a9.21,9.21,0,0,0-.3,1.65,7.61,7.61,0,0,0,2,6.06,6.42,6.42,0,0,0,6.55,1.51,8.14,8.14,0,0,0,4.42-4.27Z",
    className: "fishandtipps_svg__cls-43",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1337",
    d: "M1622,241.83l-.61,0c-3.31.47-6.29,3.12-8.24,5.85a15.51,15.51,0,0,0-1.7,3.06,15.59,15.59,0,0,1,2.55-3c-.32,1.4-.51,3.16.66,4a2.67,2.67,0,0,0,1.66.4c2.4-.09,4.36-1.9,5.86-3.77a10,10,0,0,0,2.1-3.89,1.34,1.34,0,0,0,1.18.43c0-.07,0-.14,0-.2a3.36,3.36,0,0,0-.5-2.1c-.67-.83-1.9-.86-3-.8Z",
    className: "fishandtipps_svg__cls-44",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1338",
    d: "M1613.9,259.17c-.51,2.68-2.32,4.9-3.34,7.43a90.33,90.33,0,0,1,6-6.84,1.41,1.41,0,0,0-.66-.29Z",
    className: "fishandtipps_svg__cls-43",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1339",
    d: "M1620.66,246.75c-.76,1.41-1.92,2.27-2.58,1.91s-.58-1.79.18-3.2,1.91-2.27,2.58-1.91S1621.42,245.34,1620.66,246.75Z",
    className: "fishandtipps_svg__cls-45",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1340",
    d: "M1554.69,254.15c-4.74-3.47-10.3-5.62-15.22-8.83s-9.37-8-9.89-13.83l1.38-.32-1.83-1.67c.69-.35.18-1.37-.25-2-2.45-3.64.53-9-1.76-12.78q3.87,4.77,7.33,9.85c.92,0,1.28,1.16,1.37,2.08a22.39,22.39,0,0,1,6.49,7.07c.75,1.28,1.33,3,.38,4.15a2.32,2.32,0,0,0,1.47-.35,34,34,0,0,1,11.26,16.05l-.73.6Z",
    className: "fishandtipps_svg__cls-19",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1341",
    d: "M1528,217.83c.22,3.25-1,6.94.86,9.65.43.65.94,1.67.25,2l1.83,1.67-1.38.32c.52,5.85,5,10.61,9.89,13.83,3.7,2.42,7.78,4.24,11.59,6.48a2.75,2.75,0,0,0,1.58-.72v-.77A61,61,0,0,1,1528,217.83Z",
    className: "fishandtipps_svg__cls-20",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1342",
    d: "M1527.12,214.71Z",
    className: "fishandtipps_svg__cls-20",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1343",
    d: "M1546.27,240.2a31.13,31.13,0,0,1,4.69,4.91,3.25,3.25,0,0,1,.4.15,33.84,33.84,0,0,0-7.2-7.76,2.33,2.33,0,0,1-1.48.35c1-1.13.37-2.87-.38-4.15a22.39,22.39,0,0,0-6.49-7.07c-.08-.92-.45-2.09-1.36-2.08q-3.46-5.07-7.33-9.85a6,6,0,0,1,.7,1.78q3.32,4.59,6.35,9.36l.93,0c.08.89.91,1.48,1.63,2a14.24,14.24,0,0,1,5.57,10.34A7,7,0,0,1,1546.27,240.2Z",
    className: "fishandtipps_svg__cls-16",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1344",
    d: "M1527.89,217.33a44.62,44.62,0,0,0,21.46,31,84.68,84.68,0,0,1-17.24-20.79,27.65,27.65,0,0,1-3.7-8.86l-.51-1.33Z",
    className: "fishandtipps_svg__cls-23",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1345",
    d: "M1558.46,252.49c-1.75-5.6-2-11.57-3.43-17.25s-4.51-11.45-9.88-13.84l-.75,1.2c-.32-.76-.65-1.52-1-2.27-.56.54-1.36-.28-1.82-.9-2.66-3.49-8.73-2.43-11.53-5.8q3.27,5.19,6.94,10.13c-.31.86.69,1.59,1.53,2a22.42,22.42,0,0,0,4.58,8.44c1,1.12,2.42,2.24,3.81,1.7a2.45,2.45,0,0,1-.81,1.29A33.82,33.82,0,0,0,1557.65,253l.8-.5Z",
    className: "fishandtipps_svg__cls-20",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1346",
    d: "M1532.75,215.49c3,1.26,6.88,1.34,8.85,3.94.47.62,1.27,1.43,1.83.89.32.76.65,1.51,1,2.27l.75-1.2c5.36,2.39,8.43,8.16,9.87,13.85,1.09,4.28,1.49,8.72,2.37,13a2.69,2.69,0,0,1-1.2,1.27l-.73-.24A61,61,0,0,0,1532.75,215.49Z",
    className: "fishandtipps_svg__cls-14",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1347",
    d: "M1530.09,213.63h0Z",
    className: "fishandtipps_svg__cls-20",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1348",
    d: "M1548,240a31.29,31.29,0,0,0,3.13,6c0,.15,0,.29,0,.43a33.42,33.42,0,0,1-5-9.32,2.39,2.39,0,0,0,.81-1.29c-1.38.54-2.83-.57-3.81-1.7a22.56,22.56,0,0,1-4.58-8.44c-.84-.37-1.84-1.1-1.52-2q-3.68-4.92-6.94-10.13a5.79,5.79,0,0,0,1.46,1.24q3.26,4.62,6.79,9c-.09.3-.18.6-.26.9.81.36,1.1,1.34,1.38,2.19a14.26,14.26,0,0,0,8,8.63A7,7,0,0,0,1548,240Z",
    className: "fishandtipps_svg__cls-16",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1349",
    d: "M1532.61,215.54a43.64,43.64,0,0,1,22.05,30,84.91,84.91,0,0,0-14.07-23.05,26.56,26.56,0,0,0-7.4-5.8l-.57-1.17Z",
    className: "fishandtipps_svg__cls-23",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1350",
    d: "M1558.42,254.64c-6.16-3.07-13.86-.91-20.18-3.64-4.38-1.9-7.48-5.92-9.78-10.1s-4-8.71-6.61-12.7l6.87,4.31c.48.3,1.47.11,1.13-.34q.69,2.34,1.37,4.66l1.25-.8a13.5,13.5,0,0,0,5.82,6.76c1.18.68,2.59,1.29,3.11,2.56a67.46,67.46,0,0,1,17,8.57Z",
    className: "fishandtipps_svg__cls-17",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1351",
    d: "M1557.56,254.25a2.51,2.51,0,0,0-.39-1.18l.18.36c-5.65-2.07-11.93-2-17.49-4.33a22,22,0,0,1-10.4-9c-1.37-2.31-2.29-4.85-3.6-7.19a15,15,0,0,0-3.27-4.19l-.74-.47c2.63,4,4.32,8.51,6.61,12.7s5.4,8.2,9.78,10.1c6,2.6,13.32.76,19.31,3.25Z",
    className: "fishandtipps_svg__cls-18",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1352",
    d: "M1538.29,242.8a13.55,13.55,0,0,1-5.82-6.76l-1.25.8c-.44-1.49-.87-3-1.31-4.47,0,.3-.79.39-1.19.15l-6.87-4.32c2.63,4,4.32,8.51,6.61,12.7s5.4,8.2,9.78,10.1a15.55,15.55,0,0,0,1.92.67c-.39-.15-.77-.32-1.14-.49a16.72,16.72,0,0,1-7.59-6.42,46.42,46.42,0,0,1-2.3-5.27,48.91,48.91,0,0,0-5.8-9.54,18.78,18.78,0,0,0,5.91,3.56,39.72,39.72,0,0,0,2.31,4.67,1.87,1.87,0,0,0,.89-.54,13.87,13.87,0,0,0,7.09,6.92,2.73,2.73,0,0,1,.92.53c.16.17.27.39.43.56.81.91,2.35.4,3.46.91l-.55-.34c-.8-.3-1.59-.59-2.4-.86C1540.88,244.09,1539.48,243.48,1538.29,242.8Z",
    className: "fishandtipps_svg__cls-16",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1353",
    d: "M1529.85,232.17l.06.2A.25.25,0,0,0,1529.85,232.17Z",
    className: "fishandtipps_svg__cls-16",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1354",
    d: "M1527.42,236a24.85,24.85,0,0,0,17.74,14.58c-7.33-.11-14-5.33-17-12Z",
    className: "fishandtipps_svg__cls-23",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1355",
    d: "M1561.08,253.84c-4.47-3.57-4.88-10.13-4.53-15.84s.94-12-2.38-16.61c-2-2.78-5.11-4.52-8.3-5.74-2.34-.9-5-1.75-6.22-4a13.42,13.42,0,0,0,9.38,9.88l-.61.49a8.87,8.87,0,0,1,1.64,3.94,3.08,3.08,0,0,1,2-.49,3.8,3.8,0,0,1-.94,1.77c.29,2,.59,4,.89,5.93,1.1,7.36,2.6,15.42,8.38,20.11l.73.51Z",
    className: "fishandtipps_svg__cls-14",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1356",
    d: "M1540.36,213.91a13.49,13.49,0,0,0,8.67,7.67l-.61.49a8.87,8.87,0,0,1,1.64,3.94,3.08,3.08,0,0,1,2-.49,3.9,3.9,0,0,1-.94,1.77q.43,3,.89,5.93a56.64,56.64,0,0,0,2.78,12l.16.05,1,.57c-1.84-4.1-2.27-8.7-2.23-13.19,0-3.26.25-6.72-1.35-9.55s-4.75-4.48-7.63-6.1a21.58,21.58,0,0,1-4.34-3.07Z",
    className: "fishandtipps_svg__cls-15",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1357",
    d: "M1549.5,220.94a6.22,6.22,0,0,1-3.69-1.23,15.71,15.71,0,0,1-5-5.38l-.45-.42a13.49,13.49,0,0,0,8.67,7.67l-.61.49a8.87,8.87,0,0,1,1.64,3.94,3.08,3.08,0,0,1,2-.49,3.9,3.9,0,0,1-.94,1.77q.43,3,.89,5.93c.2,1.36.42,2.75.68,4.13l0,.08a49.74,49.74,0,0,0-.76-9,1.75,1.75,0,0,1,0-.79,4.63,4.63,0,0,1,.36-.65,1.91,1.91,0,0,0-.26-2.17,2.2,2.2,0,0,0-1.75.27,5,5,0,0,0-.66-2,2.22,2.22,0,0,1-.09-2.08Z",
    className: "fishandtipps_svg__cls-16",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1358",
    d: "M1542.77,215.64a28.12,28.12,0,0,1,7.67,4.73,11.83,11.83,0,0,1,4,7.86,28.94,28.94,0,0,1-.15,2.94,58.7,58.7,0,0,0,.54,10.68c-1.54-2.92-1.5-6.39-1.5-9.69s-.15-6.81-2-9.56c-2-3-5.44-4.44-8.28-6.57l-.3-.39Z",
    className: "fishandtipps_svg__cls-19",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1359",
    d: "M1591.21,296.34a134.27,134.27,0,0,0-20-27.56c-2.08-2.21-4.41-5.15-3.21-7.94a187.79,187.79,0,0,1,26,33.52c.32.53.55,1.39,0,1.63Z",
    className: "fishandtipps_svg__cls-42",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1360",
    d: "M1570.63,244.18a16.82,16.82,0,0,0-13.79-6.46,39.12,39.12,0,0,1-11.63,13.57,17.68,17.68,0,0,0,4.07,10.34c5.64,6.89,15,8.57,20.88,3.74S1576.26,251.06,1570.63,244.18Z",
    className: "fishandtipps_svg__cls-42",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1361",
    d: "M1570.63,244.18a16.83,16.83,0,0,0-13.79-6.46l-.37.67a24.28,24.28,0,0,1,4.1,5.25,34,34,0,0,1,4.4,9.15,13.49,13.49,0,0,1-.84,9.9,10.28,10.28,0,0,1-6.23,4.79,13.15,13.15,0,0,0,12.27-2.11C1576.05,260.55,1576.26,251.06,1570.63,244.18Z",
    className: "fishandtipps_svg__cls-43",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1362",
    d: "M1545.21,251.29a17.71,17.71,0,0,0,4.07,10.35,18.15,18.15,0,0,0,2.43,2.45,9.75,9.75,0,0,1-.7-4.53,3.14,3.14,0,0,1,.58-1.77,6,6,0,0,1,1.36-1c2-1.36,2.88-3.85,3.4-6.21a28,28,0,0,0,.17-12.26A38.74,38.74,0,0,1,1545.21,251.29Z",
    className: "fishandtipps_svg__cls-44",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1363",
    d: "M1567.86,265.39c2,.38,3.54,1.93,4.92,3.41q5.94,6.33,11.54,12.94c-4.92-6.61-10.56-12.95-14.12-20.48l-.58.6Z",
    className: "fishandtipps_svg__cls-43",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1364",
    d: "M1550.22,253.68c.52,1.47.2,2.92-.73,3.25s-2.11-.58-2.63-2-.2-2.92.73-3.26S1549.69,252.22,1550.22,253.68Z",
    className: "fishandtipps_svg__cls-45",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1365",
    d: "M1552.13,249.66c.28.78.12,1.55-.36,1.73s-1.1-.33-1.38-1.11-.12-1.56.36-1.73S1551.85,248.87,1552.13,249.66Z",
    className: "fishandtipps_svg__cls-45",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1366",
    d: "M1569.94,304.54c-.14-1.63-.22-2.57-.27-4.09-.18-6.49,1.87-13.17,6.34-17.87s11.52-7.09,17.75-5.26c8.31,2.43,13.06,11.15,15.5,19.46,1,3.49,1.68,7.62-.6,10.45a10.4,10.4,0,0,1-3.44,2.55,32.73,32.73,0,0,1-35.11-4l-.18-1.26Z",
    className: "fishandtipps_svg__cls-24",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1367",
    d: "M1609.26,296.78c-2.34-8-6.86-16.38-14.63-19.15a20.23,20.23,0,0,1-3.81,12.69c-2.85,4.14-6.79,7.4-10.85,10.38a22.44,22.44,0,0,1-6.48,3.66,10,10,0,0,1-3.51.45l.14,1a32.71,32.71,0,0,0,35.1,4,10.34,10.34,0,0,0,3.45-2.55c2.27-2.83,1.62-7,.59-10.45Z",
    className: "fishandtipps_svg__cls-25",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1368",
    d: "M1593.76,277.32c-6.23-1.83-13.27.56-17.75,5.26s-6.52,11.38-6.34,17.87c0,1.52.13,2.46.27,4.09l.17,1.26c.28.23.57.44.86.66.4-4.85,1-9.74,3.28-14a21,21,0,0,1,18-11.06,20.73,20.73,0,0,1,11.41,3.38A19,19,0,0,0,1593.76,277.32Z",
    className: "fishandtipps_svg__cls-26",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1369",
    d: "M1590.51,284.42c-.78,1.26-2.13,1.84-3,1.29s-1-2-.17-3.28,2.13-1.83,3-1.29,1,2,.16,3.28Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1370",
    d: "M1585,293.14c-.61,1.32-1.67,2.14-2.37,1.81s-.75-1.65-.14-3,1.66-2.14,2.36-1.82S1585.59,291.82,1585,293.14Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1371",
    d: "M1590.72,301.25c.19,1-.72,2-2,2.28a2.17,2.17,0,0,1-2.7-1.37c-.19-1,.71-2,2-2.27A2.18,2.18,0,0,1,1590.72,301.25Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1372",
    d: "M1579.06,302a1.59,1.59,0,1,1-1.41-1.78,1.58,1.58,0,0,1,1.41,1.78Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1373",
    d: "M1604.7,291.54a2.54,2.54,0,1,1-2.6-2.48h.33A2.38,2.38,0,0,1,1604.7,291.54Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1374",
    d: "M1590.81,285c-.77,1.23-2.08,1.79-2.93,1.25s-.93-2-.17-3.18,2.08-1.79,2.94-1.25S1591.58,283.79,1590.81,285Z",
    className: "fishandtipps_svg__cls-28",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1375",
    d: "M1594.08,290.6",
    className: "fishandtipps_svg__cls-9",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1376",
    d: "M1585.41,293.49c-.6,1.29-1.63,2.08-2.31,1.77s-.73-1.61-.14-2.9,1.63-2.08,2.3-1.76S1586,292.21,1585.41,293.49Z",
    className: "fishandtipps_svg__cls-28",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1377",
    d: "M1591,301.39c.19,1-.7,2-2,2.2a2.13,2.13,0,0,1-2.64-1.33c-.19-1,.7-2,2-2.2A2.12,2.12,0,0,1,1591,301.39Z",
    className: "fishandtipps_svg__cls-29",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1378",
    d: "M1579.64,302.11a1.55,1.55,0,1,1-1.37-1.73,1.55,1.55,0,0,1,1.37,1.73Z",
    className: "fishandtipps_svg__cls-29",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1379",
    d: "M1604.66,291.94a2.48,2.48,0,1,1-2.55-2.41h.33A2.33,2.33,0,0,1,1604.66,291.94Z",
    className: "fishandtipps_svg__cls-29",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1380",
    d: "M1579.59,285.3c-1.6,1.93-3.43,3.06-4.09,2.51s.1-2.55,1.69-4.49,3.42-3.05,4.09-2.51-.1,2.56-1.69,4.49Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1381",
    d: "M1574.82,290.55a.93.93,0,0,1-1.14.67.94.94,0,0,1,.33-1.84A1,1,0,0,1,1574.82,290.55Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1382",
    d: "M1585.33,200.34a22.83,22.83,0,0,1-2.34-18.13,12.12,12.12,0,0,0,6.7,11.14c1.89.91,4,1.31,5.82,2.38s3.3,3.17,2.7,5.19a9.45,9.45,0,0,1,3.62-1.13v3.41c.57-1.43,1.14-2.86,1.7-4.29l-4.25,1.22c2.48-1.06,1.87-4.37-.24-5.89s-5-2-7.51-3c-5.93-2.54-8.83-9.07-6.32-14.2A16.71,16.71,0,0,0,1585.33,200.34Z",
    className: "fishandtipps_svg__cls-46",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1383",
    d: "M1601.83,203.22V204c2.64,1,3.78,4.08,4.28,6.86a35.74,35.74,0,0,1-1.15,16.78c.09-.13.18-.26.26-.39a20.64,20.64,0,0,0-.45-23.28l-2.94-.7Z",
    className: "fishandtipps_svg__cls-46",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1384",
    d: "M1626.94,204.57c-1.59-1.07-3.47-1.76-4.86-3.09s-2.13-3.68-.89-5.16a6.52,6.52,0,0,0-1,1.05,5.56,5.56,0,0,0,1.32,4.27c1.3,1.58,3.11,2.65,4.56,4.08,4.66,4.56,5,12.11,3,18.31s-5.87,11.46-8.89,17.17c4.09-5.55,8.82-10.79,11.2-17.25,2.48-6.7,1.57-15.38-4.35-19.38Z",
    className: "fishandtipps_svg__cls-23",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1385",
    d: "M1601.87,311.53c2.09-4,4.85-8.42,8.55-11a16.88,16.88,0,0,1,12.85-3.05c5.67,1.17,10.1,5.88,12.45,11.17a5.57,5.57,0,0,1,.65,3.4c-.44,2-2.62,3-4.58,3.54-6.15,1.7-12.66,1.46-19,1-3.26-.23-6.64-.54-9.49-2.14-1-.57-2.16-1.8-1.52-2.75Z",
    className: "fishandtipps_svg__cls-7",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "fishandtipps_svg__cls-47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fishandtipps_svg__Group_108"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fishandtipps_svg__Rectangle_70",
    width: 34.87,
    height: 19.1,
    x: 1565.82,
    y: 258.94,
    className: "fishandtipps_svg__cls-48"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1387",
    d: "M1623.27,297.45a16.84,16.84,0,0,0-12.85,3.05c-3.7,2.6-6.46,7-8.55,11l-.12.16a1.46,1.46,0,0,0,.31,1.75,16.65,16.65,0,0,1,9.71-10.12,19,19,0,0,1,14.71.62,3.8,3.8,0,0,0,2.52.57c.55-.16,1-.59,1.59-.65a2.38,2.38,0,0,1,1.61.58,15.7,15.7,0,0,1,2.48,2.12C1632.18,302.15,1628.19,298.47,1623.27,297.45Z",
    className: "fishandtipps_svg__cls-9",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1388",
    d: "M1622.31,307.23a1.91,1.91,0,0,1-1.54,2.12,1.79,1.79,0,0,1-2.33-1v0a1.91,1.91,0,0,1,1.54-2.12,1.8,1.8,0,0,1,2.34,1Z",
    className: "fishandtipps_svg__cls-10",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1389",
    d: "M1612.07,306.66a1.78,1.78,0,1,1-1.7-1.86h.15a1.7,1.7,0,0,1,1.55,1.84Z",
    className: "fishandtipps_svg__cls-10",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1390",
    d: "M1619.3,300.7a1,1,0,0,1-2.08-.11,1,1,0,0,1,1.1-1h.08A1,1,0,0,1,1619.3,300.7Z",
    className: "fishandtipps_svg__cls-10",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1391",
    d: "M1631.59,309.3a1.93,1.93,0,0,1-2.34,1.32c-1.18-.16-2-1-1.91-1.9a1.94,1.94,0,0,1,2.34-1.33C1630.86,307.56,1631.72,308.41,1631.59,309.3Z",
    className: "fishandtipps_svg__cls-10",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1392",
    d: "M1620.73,313.68c.09.39-.28.81-.82.95s-1.06-.07-1.15-.46.29-.81.84-.94,1.05.06,1.13.45Z",
    className: "fishandtipps_svg__cls-10",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1393",
    d: "M1622.27,307.52a2.07,2.07,0,1,1-2.82-.79,2,2,0,0,1,.48-.2A1.82,1.82,0,0,1,1622.27,307.52Z",
    className: "fishandtipps_svg__cls-12",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1394",
    d: "M1612,306.92a1.79,1.79,0,1,1-1.77-1.8h.22A1.68,1.68,0,0,1,1612,306.92Z",
    className: "fishandtipps_svg__cls-11",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1395",
    d: "M1619.23,301.23a1.05,1.05,0,0,1-1.07,1,1,1,0,0,1,0-2.09h.13A1,1,0,0,1,1619.23,301.23Z",
    className: "fishandtipps_svg__cls-11",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1396",
    d: "M1631.56,309.56c-.11.85-1.16,1.42-2.34,1.26s-2-1-1.92-1.84a1.94,1.94,0,0,1,2.34-1.26C1630.82,307.88,1631.68,308.7,1631.56,309.56Z",
    className: "fishandtipps_svg__cls-12",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1397",
    d: "M1620.73,313.72c.08.37-.28.78-.83.9s-1.05-.07-1.14-.44.28-.78.83-.9S1620.64,313.35,1620.73,313.72Z",
    className: "fishandtipps_svg__cls-12",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1398",
    d: "M1626.54,300.84c-.16.69-1.38,1-2.72.65s-2.28-1.14-2.11-1.83,1.39-1,2.72-.65S1626.71,300.16,1626.54,300.84Z",
    className: "fishandtipps_svg__cls-13",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1399",
    d: "M1614.3,301.09a.81.81,0,0,1-.92.7.83.83,0,0,1-.7-.92.82.82,0,0,1,.81-.71A.88.88,0,0,1,1614.3,301.09Z",
    className: "fishandtipps_svg__cls-13",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1400",
    d: "M1542.82,300.33c1-2.54,2.4-5.32,4.23-7a7,7,0,0,1,6.34-1.93c2.8.74,5,3.71,6.16,7.05a4.52,4.52,0,0,1,.32,2.15,3.09,3.09,0,0,1-2.27,2.24c-3,1.07-6.25.92-9.4.64a9.06,9.06,0,0,1-4.69-1.35c-.5-.36-1.06-1.13-.74-1.74l0-.1Z",
    className: "fishandtipps_svg__cls-7",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "fishandtipps_svg__cls-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fishandtipps_svg__Group_109"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fishandtipps_svg__Rectangle_71",
    width: 17.23,
    height: 12.06,
    x: 1506.93,
    y: 252.8,
    className: "fishandtipps_svg__cls-50"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1402",
    d: "M1553.4,291.44a7,7,0,0,0-6.35,1.93c-1.83,1.64-3.19,4.42-4.22,7l-.06.1a1.09,1.09,0,0,0,.15,1.1,9.82,9.82,0,0,1,4.8-6.39,7.53,7.53,0,0,1,7.27.39c.39.24.82.51,1.24.36.27-.1.5-.37.78-.41a1,1,0,0,1,.8.37,8.7,8.7,0,0,1,1.23,1.34c-1.24-2.79-3.2-5.11-5.64-5.75Z",
    className: "fishandtipps_svg__cls-9",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1403",
    d: "M1552.93,297.62a1.22,1.22,0,0,1-.77,1.33.85.85,0,0,1-1.11-.46,1.21,1.21,0,0,1,0-.18,1.23,1.23,0,0,1,.77-1.34.84.84,0,0,1,1.1.46A.6.6,0,0,1,1552.93,297.62Z",
    className: "fishandtipps_svg__cls-10",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1404",
    d: "M1547.86,297.25a.89.89,0,0,1-.9.88h-.07a1,1,0,0,1-.76-1.17.89.89,0,0,1,.9-.87h.07A1,1,0,0,1,1547.86,297.25Z",
    className: "fishandtipps_svg__cls-10",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1405",
    d: "M1551.44,293.5a.53.53,0,0,1-.54.51h0a.61.61,0,0,1-.45-.69.52.52,0,0,1,.53-.52h0a.62.62,0,0,1,.45.69Z",
    className: "fishandtipps_svg__cls-10",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1406",
    d: "M1557.51,298.92a1,1,0,0,1-1.07.85h-.09a1.14,1.14,0,0,1-.94-1.2,1,1,0,0,1,1.07-.86l.09,0A1.13,1.13,0,0,1,1557.51,298.92Z",
    className: "fishandtipps_svg__cls-10",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1407",
    d: "M1552.15,301.69a.58.58,0,0,1-.41.6.41.41,0,0,1-.54-.21l0-.08a.58.58,0,0,1,.41-.6.42.42,0,0,1,.54.21.24.24,0,0,1,0,.08Z",
    className: "fishandtipps_svg__cls-10",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1408",
    d: "M1552.91,297.8a1.15,1.15,0,0,1-.76,1.28.85.85,0,0,1-1.11-.47.88.88,0,0,1,0-.15,1.17,1.17,0,0,1,.76-1.29.86.86,0,0,1,1.11.48A.88.88,0,0,1,1552.91,297.8Z",
    className: "fishandtipps_svg__cls-12",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1409",
    d: "M1547.85,297.42a.87.87,0,0,1-.91.83h-.07a1,1,0,0,1-.76-1.13.87.87,0,0,1,.9-.84h.07A1,1,0,0,1,1547.85,297.42Z",
    className: "fishandtipps_svg__cls-11",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1410",
    d: "M1551.4,293.82a.5.5,0,0,1-.5.5h-.07a.6.6,0,0,1-.44-.67.5.5,0,0,1,.52-.49h0A.59.59,0,0,1,1551.4,293.82Z",
    className: "fishandtipps_svg__cls-11",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1411",
    d: "M1557.5,299.08a1,1,0,0,1-1.07.82l-.09,0a1.11,1.11,0,0,1-.95-1.16,1,1,0,0,1,1.07-.81h.09A1.14,1.14,0,0,1,1557.5,299.08Z",
    className: "fishandtipps_svg__cls-12",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1412",
    d: "M1552.14,301.72a.55.55,0,0,1-.4.57.42.42,0,0,1-.55-.23s0,0,0-.05a.56.56,0,0,1,.4-.58.42.42,0,0,1,.55.22A.14.14,0,0,1,1552.14,301.72Z",
    className: "fishandtipps_svg__cls-12",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1413",
    d: "M1555,293.58c-.09.44-.69.62-1.34.41s-1.13-.72-1-1.15.69-.62,1.35-.41S1555.1,293.15,1555,293.58Z",
    className: "fishandtipps_svg__cls-13",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1414",
    d: "M1549,293.74c0,.32-.18.58-.4.58s-.4-.26-.4-.58.18-.59.4-.59S1549,293.41,1549,293.74Z",
    className: "fishandtipps_svg__cls-13",
    transform: "translate(-35.75 -38.86)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "fishandtipps_svg__slice5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1415",
    d: "M1699.42,313c2.56-4.92,5.94-10.32,10.48-13.51s10.32-4.87,15.75-3.74c7,1.43,12.38,7.2,15.27,13.69a6.87,6.87,0,0,1,.79,4.17c-.54,2.43-3.21,3.69-5.61,4.35-7.55,2.08-15.53,1.79-23.33,1.24-4-.27-8.15-.66-11.64-2.62-1.23-.69-2.64-2.2-1.86-3.37Z",
    className: "fishandtipps_svg__cls-24",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1416",
    d: "M1727.3,296.21c-.7,1.52-.18,3.69-.42,5.51-.46,3.42-3.81,5.58-6.84,7.26-3.48,1.94-7,3.89-10.9,4.78a15.3,15.3,0,0,1-9.72-.73h0l-.14.2c-.78,1.18.63,2.68,1.86,3.37,3.5,2,7.63,2.35,11.64,2.63,7.8.54,15.78.83,23.33-1.24,2.4-.66,5.07-1.92,5.61-4.35a6.9,6.9,0,0,0-.79-4.18c-2.66-6-7.46-11.31-13.63-13.25Z",
    className: "fishandtipps_svg__cls-25",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1417",
    d: "M1725.65,295.77c-5.44-1.12-11.21.56-15.75,3.75s-7.92,8.59-10.49,13.51l-.14.21a1.79,1.79,0,0,0,.38,2.14,20.41,20.41,0,0,1,11.9-12.41,23.25,23.25,0,0,1,18,.77,4.63,4.63,0,0,0,3.08.7c.68-.19,1.25-.73,1.95-.8a3,3,0,0,1,2,.71,20.45,20.45,0,0,1,3,2.6C1736.57,301.53,1731.69,297,1725.65,295.77Z",
    className: "fishandtipps_svg__cls-26",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1418",
    d: "M1724.48,307.77a2.36,2.36,0,0,1-1.89,2.6,2.22,2.22,0,0,1-2.87-1.23v0a2.34,2.34,0,0,1,1.9-2.6,2.2,2.2,0,0,1,2.86,1.23Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1419",
    d: "M1711.92,307.06a2.18,2.18,0,1,1-2.08-2.28h.19A2.1,2.1,0,0,1,1711.92,307.06Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1420",
    d: "M1720.78,299.77a1.27,1.27,0,1,1-1.2-1.35h.1A1.23,1.23,0,0,1,1720.78,299.77Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1421",
    d: "M1735.86,310.3c-.15,1.09-1.43,1.82-2.88,1.62s-2.48-1.24-2.34-2.33,1.44-1.81,2.88-1.62,2.49,1.24,2.34,2.33Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1422",
    d: "M1722.54,315.67c.11.48-.35,1-1,1.16s-1.29-.08-1.4-.55.35-1,1-1.16S1722.44,315.2,1722.54,315.67Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1423",
    d: "M1724.43,308.12a2.54,2.54,0,1,1-3.45-1,2.42,2.42,0,0,1,.58-.23A2.24,2.24,0,0,1,1724.43,308.12Z",
    className: "fishandtipps_svg__cls-29",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1424",
    d: "M1711.87,307.39a2.19,2.19,0,1,1-2.17-2.21l.27,0A2.06,2.06,0,0,1,1711.87,307.39Z",
    className: "fishandtipps_svg__cls-28",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1425",
    d: "M1720.7,300.41a1.29,1.29,0,0,1-1.31,1.25,1.28,1.28,0,0,1,0-2.56h.15A1.22,1.22,0,0,1,1720.7,300.41Z",
    className: "fishandtipps_svg__cls-28",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1426",
    d: "M1735.82,310.62c-.15,1.05-1.43,1.74-2.87,1.55s-2.49-1.2-2.35-2.26,1.42-1.74,2.86-1.55S1736,309.57,1735.82,310.62Z",
    className: "fishandtipps_svg__cls-29",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1427",
    d: "M1722.53,315.73c.11.45-.34.95-1,1.11s-1.3-.09-1.4-.54.34-1,1-1.12S1722.43,315.27,1722.53,315.73Z",
    className: "fishandtipps_svg__cls-29",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1428",
    d: "M1729.67,299.94c-.2.84-1.7,1.19-3.34.8s-2.79-1.4-2.59-2.24,1.7-1.2,3.34-.8,2.79,1.4,2.59,2.24Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1429",
    d: "M1714.66,300.24a1,1,0,1,1-1-1.14A1.08,1.08,0,0,1,1714.66,300.24Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1430",
    d: "M1687.42,315.13c-3-7.66-3-16.1-3.43-24.31s-1.41-16.78-6-23.6a37.72,37.72,0,0,1-2.85-4.34,10.86,10.86,0,0,1,2.81-12.73,4.27,4.27,0,0,1,3.76-1.15,4.2,4.2,0,0,1,2,1.55c2.33,3,3,7.06,5.52,9.84a2.51,2.51,0,0,0,1.75,1c1.46,0,2-1.92,1.92-3.37a18.84,18.84,0,0,0-3-9.17,52,52,0,0,1-3.14-4.75,10.79,10.79,0,0,1-1-6.57,8.62,8.62,0,0,1,4.21-6.25,6.17,6.17,0,0,1,7.2,1c2.33,2.5,2.47,7.35,5.82,8,3.51-1.55,2.37-8.22,6.08-9.2,1.65-.43,3.29.66,4.61,1.75a10.31,10.31,0,0,1,2.69,3c1.69,3.2,0,7.05-1.44,10.35s-2.73,7.45-.47,10.28c1.9,2.38,5.55,2.61,8.39,1.53s5.15-3.19,7.63-5,5.42-3.25,8.44-2.83a10.09,10.09,0,0,1,6.58,4.52c2.43,3.45,3.22,8.67.23,11.65a12.71,12.71,0,0,1-4.4,2.48l-10.23,4.08c-2.75,1.09-5.7,2.36-7.15,4.94s-.13,6.73,2.82,6.83c2.45.08,4.79-2.53,7-1.47,1.33.65,1.77,2.35,1.69,3.83-.2,3.68-2.59,6.88-5.23,9.47-3.56,3.48-7.77,6.37-10.57,10.48-1.85,2.71-3.08,5.92-5.57,8.05s-5.53,2.77-8.58,3.37c-5.94,1.17-12.78,1.81-17.39-2.11l-.77-1.11Z",
    className: "fishandtipps_svg__cls-51",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1431",
    d: "M1721.38,295.84c-3.69,4-5.49,9.3-8.53,13.78s-8.37,8.34-13.56,6.79c-3.51-1.05-6-4.37-7-7.88s-.94-7.24-.91-10.9q.07-10.29-.78-20.55c-.2-2.4-.5-4.94-1.94-6.87-2.52-3.37-7.42-3.65-11-5.87a11,11,0,0,1-3.12-3,9.81,9.81,0,0,0,.58,1.51,36.06,36.06,0,0,0,2.85,4.34c4.6,6.82,5.6,15.39,6,23.6s.43,16.66,3.43,24.31l.77,1.12c4.61,3.91,11.45,3.28,17.39,2.1,3.05-.6,6.22-1.35,8.58-3.37s3.72-5.34,5.57-8.05c2.8-4.11,7-7,10.57-10.48,2.64-2.58,5-5.78,5.23-9.47a5.52,5.52,0,0,0-.18-1.81q-2.94,2.37-6,4.53C1726.56,291.6,1723.67,293.39,1721.38,295.84Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1432",
    d: "M1739,250.11c-3-.42-6,1.08-8.44,2.84s-4.79,3.87-7.63,4.95a8.9,8.9,0,0,1-5.42.35,5.27,5.27,0,0,0,1.85,1.46c2.5,1.1,5.32-.42,7.67-1.82a23.84,23.84,0,0,1,8.54-3.53c3.07-.43,6.5.42,8.42,2.85,2.3,2.91,1.82,7.3-.2,10.4l-.12.17a8.38,8.38,0,0,0,2.14-1.49c3-3,2.2-8.2-.23-11.66A10.16,10.16,0,0,0,1739,250.11Z",
    className: "fishandtipps_svg__cls-53",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1433",
    d: "M1735.15,284.6a2.71,2.71,0,0,0-1.31-1.44c-2.2-1.06-4.54,1.54-7,1.46a3.08,3.08,0,0,1-2.2-1.05,1.82,1.82,0,0,0,.4,1.21,3.06,3.06,0,0,0,2.8.74C1730.28,285.22,1732.89,284.16,1735.15,284.6Z",
    className: "fishandtipps_svg__cls-53",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1434",
    d: "M1691.35,262.69a3.11,3.11,0,0,0,.83-1.92,1.52,1.52,0,0,1-1.2.61,2.53,2.53,0,0,1-1.76-1c-2.55-2.78-3.19-6.87-5.52-9.84a4.2,4.2,0,0,0-2-1.55,4.26,4.26,0,0,0-3.75,1.15,10.91,10.91,0,0,0-3.76,9.17,9,9,0,0,1,1-3c.93-1.58,2.81-2.76,4.57-2.27a5.65,5.65,0,0,1,2.42,1.67,28.8,28.8,0,0,1,3.27,4,10.47,10.47,0,0,0,2.39,2.9A2.88,2.88,0,0,0,1691.35,262.69Z",
    className: "fishandtipps_svg__cls-53",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1435",
    d: "M1711.2,235.73c2-.39,3.84,1.53,4.24,3.54s-.17,4-.5,6.07c-.07.44-.12.88-.17,1.33l.24-.57c1.49-3.3,3.14-7.16,1.44-10.35a10.31,10.31,0,0,0-2.69-3c-1.32-1.09-3-2.18-4.61-1.75-3.71,1-2.58,7.65-6.09,9.2-3.35-.63-3.49-5.49-5.82-8a6.15,6.15,0,0,0-7.2-1,8.63,8.63,0,0,0-4.2,6.24,10.83,10.83,0,0,0,1,6.58,16.48,16.48,0,0,0,1.33,2.16,11.7,11.7,0,0,1-.1-6.24c1-3.35,4.94-6,8-4.38,1.67.87,2.62,2.63,3.75,4.13s2.88,2.89,4.7,2.46C1707.65,241.51,1708.05,236.35,1711.2,235.73Z",
    className: "fishandtipps_svg__cls-53",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1436",
    d: "M1720.27,258.5a6.55,6.55,0,0,1-5.73-2.12c-2.26-2.83-1-7,.47-10.28.31-.69.63-1.4.92-2.12l-7.12,6.75a16.37,16.37,0,0,0-2.47,2.72,8.06,8.06,0,0,0,1,9.95,7.5,7.5,0,0,0,9.87.24,13.2,13.2,0,0,0,3-5.14Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1437",
    d: "M1715.8,243.12s0,0,0,0Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1438",
    d: "M1716.21,243.25l-.4-.12.28.45.12-.33Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1439",
    d: "M1691.23,251.23a18.71,18.71,0,0,1,1.66,6.78c.08,1.45-.46,3.37-1.91,3.37a2,2,0,0,1-1.24-.5c0,.4.06.8.08,1.2a11.09,11.09,0,0,0,.4,3.14,3.21,3.21,0,0,0,2.12,2.19,3.39,3.39,0,0,0,3.27-1.41c1.67-2.1,1.68-5.16.69-7.65a23.22,23.22,0,0,0-4.57-6.57Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1440",
    d: "M1733.41,269.8c-4.83.87-9.8,2.54-13,6.27-1.59,1.85-2.64,4.58-1.45,6.7,1.09,2,3.73,2.6,5.91,2.07a7.62,7.62,0,0,0,1.14-.38c-2.34-.77-3.28-4.35-2-6.67,1.44-2.58,4.4-3.85,7.14-4.94l9.81-3.91A56.58,56.58,0,0,0,1733.41,269.8Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1441",
    d: "M1707,274.13c0,1.64-1.7,3-3.8,3s-3.79-1.34-3.79-3,1.7-3,3.79-3S1707,272.48,1707,274.13Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1442",
    d: "M1707,273.9c0,1.51-1.7,2.74-3.8,2.74s-3.79-1.23-3.79-2.74,1.7-2.75,3.79-2.75S1707,272.38,1707,273.9Z",
    className: "fishandtipps_svg__cls-54",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1443",
    d: "M1705.79,273.93a2.66,2.66,0,1,1-3-2.26,2.31,2.31,0,0,1,.37,0A2.48,2.48,0,0,1,1705.79,273.93Z",
    className: "fishandtipps_svg__cls-55",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1444",
    d: "M1705.79,273.9c0,1.05-1.18,1.91-2.64,1.91s-2.63-.86-2.63-1.91,1.18-1.92,2.63-1.92S1705.79,272.84,1705.79,273.9Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1445",
    d: "M1707.92,258.68a2.84,2.84,0,1,1-3.47-2.07,2.84,2.84,0,0,1,3.47,2.07Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1446",
    d: "M1707.86,258.47a2.84,2.84,0,1,1-3.59-1.8l.18-.06a2.75,2.75,0,0,1,3.41,1.85Z",
    className: "fishandtipps_svg__cls-54",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1447",
    d: "M1707,258.71a2,2,0,1,1-2.47-1.64A2.12,2.12,0,0,1,1707,258.71Z",
    className: "fishandtipps_svg__cls-55",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1448",
    d: "M1707,258.68a2,2,0,1,1-2.5-1.25l.13,0A1.92,1.92,0,0,1,1707,258.68Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1449",
    d: "M1699.11,254.8a2.83,2.83,0,1,1-.93-3.92A2.83,2.83,0,0,1,1699.11,254.8Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1450",
    d: "M1699.23,254.61a2.84,2.84,0,1,1-1.21-3.82l.16.09A2.74,2.74,0,0,1,1699.23,254.61Z",
    className: "fishandtipps_svg__cls-54",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1451",
    d: "M1698.47,254.2a2,2,0,1,1-.54-2.91A2.1,2.1,0,0,1,1698.47,254.2Z",
    className: "fishandtipps_svg__cls-55",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1452",
    d: "M1698.49,254.17a2,2,0,1,1-.84-2.67l.11.07A1.91,1.91,0,0,1,1698.49,254.17Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1453",
    d: "M1709.53,248.15a2.84,2.84,0,1,1-2.62-3.08,2.84,2.84,0,0,1,2.62,3.08Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1454",
    d: "M1709.54,247.93a2.84,2.84,0,1,1-2.82-2.86h.19A2.76,2.76,0,0,1,1709.54,247.93Z",
    className: "fishandtipps_svg__cls-54",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1455",
    d: "M1708.68,247.89a2,2,0,1,1-1.8-2.34A2.09,2.09,0,0,1,1708.68,247.89Z",
    className: "fishandtipps_svg__cls-55",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1456",
    d: "M1708.68,247.86a2,2,0,1,1-2-2h.13a1.92,1.92,0,0,1,1.83,2Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1457",
    d: "M1684.55,256.07a3.57,3.57,0,0,1-3.26,3.81,3.86,3.86,0,0,1,0-7.62A3.57,3.57,0,0,1,1684.55,256.07Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1458",
    d: "M1684.55,255.78a3.39,3.39,0,0,1-3.26,3.51,3.52,3.52,0,0,1,0-7A3.4,3.4,0,0,1,1684.55,255.78Z",
    className: "fishandtipps_svg__cls-54",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1459",
    d: "M1683.56,255.82c0,1.62-1,2.93-2.27,2.93s-2.27-1.31-2.27-2.93,1-2.93,2.27-2.93S1683.56,254.2,1683.56,255.82Z",
    className: "fishandtipps_svg__cls-55",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1460",
    d: "M1683.56,255.77a2.37,2.37,0,0,1-2.27,2.45,2.45,2.45,0,0,1,0-4.89A2.36,2.36,0,0,1,1683.56,255.77Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1461",
    d: "M1686.43,266.77a3.39,3.39,0,0,1-3.26,3.51,3.52,3.52,0,0,1,0-7A3.41,3.41,0,0,1,1686.43,266.77Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1462",
    d: "M1686.43,266.49a3.26,3.26,0,1,1-3.28-3.24h0a3.25,3.25,0,0,1,3.26,3.24Z",
    className: "fishandtipps_svg__cls-54",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1463",
    d: "M1685.43,266.53a2.5,2.5,0,0,1-2.27,2.7,2.74,2.74,0,0,1,0-5.4A2.52,2.52,0,0,1,1685.43,266.53Z",
    className: "fishandtipps_svg__cls-55",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1464",
    d: "M1685.43,266.49a2.27,2.27,0,1,1-2.28-2.25h0a2.26,2.26,0,0,1,2.27,2.25Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1465",
    d: "M1712.71,283.29a3.27,3.27,0,1,1-3.26-3.52A3.4,3.4,0,0,1,1712.71,283.29Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1466",
    d: "M1712.71,283a3.26,3.26,0,1,1-3.27-3.25h0A3.25,3.25,0,0,1,1712.71,283Z",
    className: "fishandtipps_svg__cls-54",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1467",
    d: "M1711.72,283.06a2.3,2.3,0,1,1-2.27-2.7A2.51,2.51,0,0,1,1711.72,283.06Z",
    className: "fishandtipps_svg__cls-55",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1468",
    d: "M1711.72,283a2.27,2.27,0,1,1-2.28-2.26h0A2.27,2.27,0,0,1,1711.72,283Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1469",
    d: "M1729.37,288.54a3.27,3.27,0,1,1-3.26-3.52A3.41,3.41,0,0,1,1729.37,288.54Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1470",
    d: "M1729.37,288.27a3.26,3.26,0,1,1-3.28-3.25h0a3.26,3.26,0,0,1,3.26,3.24Z",
    className: "fishandtipps_svg__cls-54",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1471",
    d: "M1728.38,288.31a2.3,2.3,0,1,1-2.27-2.7A2.52,2.52,0,0,1,1728.38,288.31Z",
    className: "fishandtipps_svg__cls-55",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1472",
    d: "M1728.38,288.27a2.27,2.27,0,1,1-2.28-2.26h0a2.27,2.27,0,0,1,2.27,2.26Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1473",
    d: "M1720.43,288.27a3.27,3.27,0,1,1-3.26-3.52A3.41,3.41,0,0,1,1720.43,288.27Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1474",
    d: "M1720.43,288a3.26,3.26,0,1,1-3.28-3.25h0a3.26,3.26,0,0,1,3.26,3.24Z",
    className: "fishandtipps_svg__cls-54",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1475",
    d: "M1719.43,288a2.3,2.3,0,1,1-4.53-.8,2.32,2.32,0,0,1,2.27-1.9A2.52,2.52,0,0,1,1719.43,288Z",
    className: "fishandtipps_svg__cls-55",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1476",
    d: "M1719.43,288a2.27,2.27,0,1,1-2.28-2.26h0A2.26,2.26,0,0,1,1719.43,288Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1477",
    d: "M1702.87,284.46a3.27,3.27,0,1,1-3.26-3.51A3.39,3.39,0,0,1,1702.87,284.46Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1478",
    d: "M1702.87,284.19a3.26,3.26,0,1,1-3.28-3.24h0a3.25,3.25,0,0,1,3.26,3.24Z",
    className: "fishandtipps_svg__cls-54",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1479",
    d: "M1701.87,284.23a2.3,2.3,0,1,1-2.26-2.7A2.51,2.51,0,0,1,1701.87,284.23Z",
    className: "fishandtipps_svg__cls-55",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1480",
    d: "M1701.87,284.19a2.27,2.27,0,1,1-2.27-2.26h0a2.26,2.26,0,0,1,2.26,2.26Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1481",
    d: "M1693.36,292.76a3.27,3.27,0,1,1-3.51-3h.25A3.15,3.15,0,0,1,1693.36,292.76Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1482",
    d: "M1693.36,292.53a3,3,0,0,1-3.26,2.78,2.82,2.82,0,1,1-.88-5.57,2.6,2.6,0,0,1,.88,0A3,3,0,0,1,1693.36,292.53Z",
    className: "fishandtipps_svg__cls-54",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1483",
    d: "M1692.36,292.56a2.27,2.27,0,1,1-2.26-2.32,2.27,2.27,0,0,1,2.26,2.32Z",
    className: "fishandtipps_svg__cls-55",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1484",
    d: "M1692.36,292.53a2.29,2.29,0,1,1-2.26-1.94A2.11,2.11,0,0,1,1692.36,292.53Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1485",
    d: "M1712.25,292.05a2.8,2.8,0,1,1-3-2.58h.2A2.69,2.69,0,0,1,1712.25,292.05Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1486",
    d: "M1712.25,291.85a2.83,2.83,0,1,1-3.24-2.36,3.25,3.25,0,0,1,.44,0A2.62,2.62,0,0,1,1712.25,291.85Z",
    className: "fishandtipps_svg__cls-54",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1487",
    d: "M1711.4,291.88a1.95,1.95,0,1,1-2-2A2,2,0,0,1,1711.4,291.88Z",
    className: "fishandtipps_svg__cls-55",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1488",
    d: "M1711.4,291.85a2,2,0,1,1-2.25-1.64,1.51,1.51,0,0,1,.3,0A1.82,1.82,0,0,1,1711.4,291.85Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1489",
    d: "M1703.31,297.24a2.8,2.8,0,1,1-3-2.59h.2A2.71,2.71,0,0,1,1703.31,297.24Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1490",
    d: "M1703.31,297a2.83,2.83,0,1,1-3.23-2.36,3.13,3.13,0,0,1,.43,0A2.63,2.63,0,0,1,1703.31,297Z",
    className: "fishandtipps_svg__cls-54",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1491",
    d: "M1702.46,297.07a1.95,1.95,0,1,1-1.94-2A2,2,0,0,1,1702.46,297.07Z",
    className: "fishandtipps_svg__cls-55",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1492",
    d: "M1702.46,297a2,2,0,1,1-2.25-1.64,1.55,1.55,0,0,1,.31,0A1.82,1.82,0,0,1,1702.46,297Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1493",
    d: "M1715.05,299.83a2.8,2.8,0,1,1-3-2.59h.2A2.69,2.69,0,0,1,1715.05,299.83Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1494",
    d: "M1715.05,299.63a2.83,2.83,0,1,1-3.24-2.36,3.15,3.15,0,0,1,.44,0A2.61,2.61,0,0,1,1715.05,299.63Z",
    className: "fishandtipps_svg__cls-54",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1495",
    d: "M1714.2,299.66a2,2,0,1,1-2-2,2,2,0,0,1,2,2Z",
    className: "fishandtipps_svg__cls-55",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1496",
    d: "M1714.2,299.63a2,2,0,1,1-2.26-1.64,1.62,1.62,0,0,1,.31,0A1.83,1.83,0,0,1,1714.2,299.63Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1497",
    d: "M1744.47,264.47a2.8,2.8,0,1,1-3-2.59h.2A2.7,2.7,0,0,1,1744.47,264.47Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1498",
    d: "M1744.47,264.27a2.83,2.83,0,1,1-3.24-2.36,3.15,3.15,0,0,1,.44,0A2.61,2.61,0,0,1,1744.47,264.27Z",
    className: "fishandtipps_svg__cls-54",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1499",
    d: "M1743.62,264.3a2,2,0,1,1-1.95-2A2,2,0,0,1,1743.62,264.3Z",
    className: "fishandtipps_svg__cls-55",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1500",
    d: "M1743.62,264.27a2,2,0,1,1-2.25-1.64l.3,0A1.83,1.83,0,0,1,1743.62,264.27Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1501",
    d: "M1725,263.84a3.27,3.27,0,1,1-3.26-3.52A3.41,3.41,0,0,1,1725,263.84Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1502",
    d: "M1725,263.56a3.26,3.26,0,1,1-3.28-3.24h0A3.26,3.26,0,0,1,1725,263.56Z",
    className: "fishandtipps_svg__cls-54",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1503",
    d: "M1724,263.6a2.3,2.3,0,1,1-2.27-2.7A2.53,2.53,0,0,1,1724,263.6Z",
    className: "fishandtipps_svg__cls-55",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1504",
    d: "M1724,263.56a2.27,2.27,0,1,1-2.28-2.26h0A2.27,2.27,0,0,1,1724,263.56Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1505",
    d: "M1741.67,256.52a3.27,3.27,0,1,1-3.26-3.51A3.39,3.39,0,0,1,1741.67,256.52Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1506",
    d: "M1741.67,256.25a3.26,3.26,0,1,1-3.28-3.24h0a3.25,3.25,0,0,1,3.26,3.24Z",
    className: "fishandtipps_svg__cls-54",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1507",
    d: "M1740.68,256.29a2.3,2.3,0,1,1-2.27-2.7A2.51,2.51,0,0,1,1740.68,256.29Z",
    className: "fishandtipps_svg__cls-55",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1508",
    d: "M1740.68,256.25a2.27,2.27,0,1,1-2.28-2.26h0A2.27,2.27,0,0,1,1740.68,256.25Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1509",
    d: "M1734.9,263.25a3.26,3.26,0,1,1-3.28-3.24h0a3.26,3.26,0,0,1,3.26,3.24Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1510",
    d: "M1734.9,263a3.27,3.27,0,1,1-3.54-3h.28A3.14,3.14,0,0,1,1734.9,263Z",
    className: "fishandtipps_svg__cls-54",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1511",
    d: "M1733.9,263a2.28,2.28,0,1,1-2.26-2.49A2.38,2.38,0,0,1,1733.9,263Z",
    className: "fishandtipps_svg__cls-55",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1512",
    d: "M1733.9,263a2.27,2.27,0,1,1-2.46-2.07h.2A2.17,2.17,0,0,1,1733.9,263Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1513",
    d: "M1714.21,266.45a3.31,3.31,0,1,1-3.82-2.7,2.59,2.59,0,0,1,.56-.05A3,3,0,0,1,1714.21,266.45Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1514",
    d: "M1714.21,266.23c0,1.4-1.46,2.54-3.26,2.54s-3.26-1.14-3.26-2.54,1.46-2.53,3.26-2.53S1714.21,264.83,1714.21,266.23Z",
    className: "fishandtipps_svg__cls-54",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1515",
    d: "M1713.22,266.26a2.28,2.28,0,1,1-2.43-2.1h.16A2.2,2.2,0,0,1,1713.22,266.26Z",
    className: "fishandtipps_svg__cls-55",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1516",
    d: "M1713.22,266.23a2.34,2.34,0,1,1-2.84-1.69,2.61,2.61,0,0,1,.57-.08A2.08,2.08,0,0,1,1713.22,266.23Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1517",
    d: "M1702.84,266.61a3.31,3.31,0,1,1-3.55-3.05,2.62,2.62,0,0,1,.56,0A3,3,0,0,1,1702.84,266.61Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1518",
    d: "M1702.85,266.4c-.13,1.39-1.69,2.39-3.48,2.22s-3.14-1.44-3-2.83,1.7-2.39,3.49-2.23S1703,265,1702.85,266.4Z",
    className: "fishandtipps_svg__cls-54",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1519",
    d: "M1701.87,266.34a2.28,2.28,0,1,1-2.22-2.33h.16A2.21,2.21,0,0,1,1701.87,266.34Z",
    className: "fishandtipps_svg__cls-55",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1520",
    d: "M1701.87,266.3a2.34,2.34,0,1,1-2.67-1.95,2.79,2.79,0,0,1,.58,0A2.07,2.07,0,0,1,1701.87,266.3Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1521",
    d: "M1692.67,283.21a3,3,0,0,1-3.5,2.43,2.79,2.79,0,1,1-.41-5.56,2.67,2.67,0,0,1,.93.08A3.05,3.05,0,0,1,1692.67,283.21Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1522",
    d: "M1692.69,283c-.13,1.39-1.69,2.39-3.49,2.22s-3.13-1.44-3-2.84,1.69-2.38,3.48-2.22,3.14,1.44,3,2.84Z",
    className: "fishandtipps_svg__cls-54",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1523",
    d: "M1691.7,282.93a2.28,2.28,0,1,1-2.22-2.32h.16A2.19,2.19,0,0,1,1691.7,282.93Z",
    className: "fishandtipps_svg__cls-55",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1524",
    d: "M1691.7,282.9a2.07,2.07,0,0,1-2.42,1.55,1.82,1.82,0,1,1-.56-3.6,1.8,1.8,0,0,1,.89.08A2.07,2.07,0,0,1,1691.7,282.9Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1525",
    d: "M1695,269.05a3.26,3.26,0,1,1-3.28-3.24h0a3.24,3.24,0,0,1,3.26,3.24Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1526",
    d: "M1695,268.8a3.27,3.27,0,1,1-3.54-3h.28A3.13,3.13,0,0,1,1695,268.8Z",
    className: "fishandtipps_svg__cls-54",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1527",
    d: "M1694,268.84a2.28,2.28,0,1,1-2.27-2.5A2.4,2.4,0,0,1,1694,268.84Z",
    className: "fishandtipps_svg__cls-55",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1528",
    d: "M1694,268.8a2.28,2.28,0,1,1-2.47-2.07h.2A2.18,2.18,0,0,1,1694,268.8Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1529",
    d: "M1696.43,275.9c0,1.37-1.42,2.48-3.17,2.48s-3.16-1.11-3.16-2.48,1.41-2.47,3.16-2.47S1696.43,274.54,1696.43,275.9Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1530",
    d: "M1696.43,275.71c0,1.27-1.42,2.29-3.17,2.29s-3.16-1-3.16-2.29,1.41-2.28,3.16-2.28S1696.43,274.45,1696.43,275.71Z",
    className: "fishandtipps_svg__cls-54",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1531",
    d: "M1695.47,275.74a2.23,2.23,0,1,1-2.53-1.87l.33,0A2.08,2.08,0,0,1,1695.47,275.74Z",
    className: "fishandtipps_svg__cls-55",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1532",
    d: "M1695.47,275.71c0,.88-1,1.59-2.2,1.59s-2.2-.71-2.2-1.59,1-1.58,2.2-1.58S1695.47,274.84,1695.47,275.71Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1533",
    d: "M1718.51,277.3c0,1.37-1.42,2.47-3.17,2.47s-3.16-1.1-3.16-2.47,1.42-2.47,3.16-2.47S1718.51,275.94,1718.51,277.3Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1534",
    d: "M1718.51,277.11c0,1.26-1.42,2.28-3.17,2.28s-3.16-1-3.16-2.28,1.42-2.28,3.16-2.28S1718.51,275.85,1718.51,277.11Z",
    className: "fishandtipps_svg__cls-54",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1535",
    d: "M1717.54,277.14a2.22,2.22,0,1,1-2.53-1.88l.33,0A2.06,2.06,0,0,1,1717.54,277.14Z",
    className: "fishandtipps_svg__cls-55",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1536",
    d: "M1717.54,277.11c0,.88-1,1.59-2.2,1.59s-2.2-.71-2.2-1.59,1-1.59,2.2-1.59S1717.54,276.23,1717.54,277.11Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1537",
    d: "M1695.53,238a3.83,3.83,0,1,1-3.84-3.81h0a3.82,3.82,0,0,1,3.83,3.8Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1538",
    d: "M1695.53,237.72a3.84,3.84,0,1,1-3.51-3.51A3.85,3.85,0,0,1,1695.53,237.72Z",
    className: "fishandtipps_svg__cls-54",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1539",
    d: "M1694.36,237.77a2.67,2.67,0,0,1-5.32.51,4.34,4.34,0,0,1,0-.51,2.67,2.67,0,1,1,5.32-.52A2.26,2.26,0,0,1,1694.36,237.77Z",
    className: "fishandtipps_svg__cls-55",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1540",
    d: "M1694.36,237.72a2.67,2.67,0,1,1-2.43-2.43A2.67,2.67,0,0,1,1694.36,237.72Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1541",
    d: "M1701.12,245.05a2.63,2.63,0,1,1-2.64-2.62h0A2.63,2.63,0,0,1,1701.12,245.05Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1542",
    d: "M1701.12,244.84a2.63,2.63,0,1,1-2.85-2.4h.22A2.53,2.53,0,0,1,1701.12,244.84Z",
    className: "fishandtipps_svg__cls-54",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1543",
    d: "M1700.32,244.87a1.84,1.84,0,1,1-1.83-2A1.92,1.92,0,0,1,1700.32,244.87Z",
    className: "fishandtipps_svg__cls-55",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1544",
    d: "M1700.32,244.84a1.83,1.83,0,1,1-2-1.67h.15A1.77,1.77,0,0,1,1700.32,244.84Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1545",
    d: "M1713.37,238.61a3.92,3.92,0,1,1-3.93-3.9h0a3.91,3.91,0,0,1,3.92,3.9Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1546",
    d: "M1713.37,238.3a3.93,3.93,0,1,1-3.59-3.58A3.94,3.94,0,0,1,1713.37,238.3Z",
    className: "fishandtipps_svg__cls-54",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1547",
    d: "M1712.18,238.35a2.74,2.74,0,0,1-5.45.52,2.26,2.26,0,0,1,0-.52,2.74,2.74,0,1,1,5.45-.52A4.51,4.51,0,0,1,1712.18,238.35Z",
    className: "fishandtipps_svg__cls-55",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1548",
    d: "M1712.18,238.3a2.74,2.74,0,1,1-2.5-2.49A2.74,2.74,0,0,1,1712.18,238.3Z",
    className: "fishandtipps_svg__cls-52",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1549",
    d: "M1674.88,316.22c-.1-1.18-.17-1.87-.2-3a18.17,18.17,0,0,1,4.62-13,13.23,13.23,0,0,1,12.9-3.83c6,1.77,9.51,8.12,11.29,14.16.74,2.54,1.22,5.55-.44,7.61a7.61,7.61,0,0,1-2.5,1.85,23.81,23.81,0,0,1-25.54-2.89l-.13-.92Z",
    className: "fishandtipps_svg__cls-24",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1550",
    d: "M1703.49,310.58c-1.71-5.83-5-11.92-10.65-13.94a14.65,14.65,0,0,1-2.77,9.23,33,33,0,0,1-7.89,7.56,16.55,16.55,0,0,1-4.72,2.66,7.39,7.39,0,0,1-2.56.33l.1.72a23.81,23.81,0,0,0,25.54,2.89,7.25,7.25,0,0,0,2.5-1.85c1.66-2.06,1.18-5.07.44-7.6Z",
    className: "fishandtipps_svg__cls-25",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1551",
    d: "M1692.2,296.41a13.23,13.23,0,0,0-12.9,3.83,18.17,18.17,0,0,0-4.62,13c0,1.11.1,1.8.2,3l.12.92.63.48c.29-3.53.76-7.09,2.38-10.21a14.85,14.85,0,0,1,21.39-5.59A13.85,13.85,0,0,0,1692.2,296.41Z",
    className: "fishandtipps_svg__cls-26",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1552",
    d: "M1689.84,301.58c-.56.92-1.54,1.34-2.18.94a1.75,1.75,0,0,1-.12-2.38c.57-.92,1.55-1.34,2.19-.94A1.74,1.74,0,0,1,1689.84,301.58Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1553",
    d: "M1685.82,307.93c-.45,1-1.22,1.55-1.72,1.32s-.55-1.21-.11-2.17,1.21-1.55,1.72-1.32S1686.26,307,1685.82,307.93Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1554",
    d: "M1690,313.83a1.81,1.81,0,0,1-3.44.66c-.14-.73.52-1.47,1.47-1.65a1.58,1.58,0,0,1,2,1Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1555",
    d: "M1681.52,314.37a1.16,1.16,0,1,1-1-1.3,1.17,1.17,0,0,1,1,1.3Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1556",
    d: "M1700.17,306.76a1.85,1.85,0,0,1-3.69.09,1.84,1.84,0,0,1,1.8-1.89h.24A1.73,1.73,0,0,1,1700.17,306.76Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1557",
    d: "M1690.06,302c-.56.89-1.51,1.3-2.13.91a1.7,1.7,0,0,1-.12-2.32c.56-.89,1.51-1.3,2.13-.91S1690.62,301.13,1690.06,302Z",
    className: "fishandtipps_svg__cls-28",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1558",
    d: "M1692.44,306.08Z",
    className: "fishandtipps_svg__cls-9",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1559",
    d: "M1686.13,308.19c-.43.93-1.18,1.51-1.67,1.28s-.54-1.17-.11-2.11,1.18-1.51,1.67-1.28S1686.56,307.25,1686.13,308.19Z",
    className: "fishandtipps_svg__cls-28",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1560",
    d: "M1690.21,313.93c.14.71-.51,1.43-1.43,1.6a1.35,1.35,0,1,1,1.43-1.6Z",
    className: "fishandtipps_svg__cls-29",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1561",
    d: "M1681.94,314.45a1.13,1.13,0,1,1-1-1.26A1.14,1.14,0,0,1,1681.94,314.45Z",
    className: "fishandtipps_svg__cls-29",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1562",
    d: "M1700.14,307.06a1.8,1.8,0,1,1-1.85-1.76h.23A1.69,1.69,0,0,1,1700.14,307.06Z",
    className: "fishandtipps_svg__cls-29",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1563",
    d: "M1681.89,302.22c-1.15,1.4-2.48,2.22-3,1.83s.07-1.86,1.22-3.26,2.49-2.23,3-1.83S1683.05,300.81,1681.89,302.22Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1564",
    d: "M1678.43,306a.74.74,0,0,1-.75.71.79.79,0,1,1,.75-.83Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1565",
    d: "M1707.77,321.89c0-.53-.07-.83-.08-1.32a8,8,0,0,1,2-5.75,5.83,5.83,0,0,1,5.71-1.69c2.68.78,4.21,3.58,5,6.26.33,1.12.54,2.45-.19,3.36a3.31,3.31,0,0,1-1.11.82,10.53,10.53,0,0,1-11.3-1.28Z",
    className: "fishandtipps_svg__cls-24",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1566",
    d: "M1720.43,319.39c-.76-2.58-2.21-5.27-4.71-6.17a6.48,6.48,0,0,1-1.23,4.09,14.57,14.57,0,0,1-3.49,3.34,7,7,0,0,1-2.09,1.18,3.25,3.25,0,0,1-1.12.14l0,.32a10.53,10.53,0,0,0,11.3,1.28,3.31,3.31,0,0,0,1.11-.82c.73-.91.52-2.24.19-3.36Z",
    className: "fishandtipps_svg__cls-25",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1567",
    d: "M1715.44,313.13a5.83,5.83,0,0,0-5.71,1.69,8,8,0,0,0-2,5.75c0,.49,0,.79.08,1.32l.06.4.28.21a11.63,11.63,0,0,1,1.05-4.52,6.57,6.57,0,0,1,9.46-2.47A6,6,0,0,0,1715.44,313.13Z",
    className: "fishandtipps_svg__cls-26",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1568",
    d: "M1714.4,315.41c-.26.41-.69.59-1,.42a.8.8,0,0,1-.06-1.06c.25-.41.69-.59,1-.41S1714.65,315,1714.4,315.41Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1569",
    d: "M1712.61,318.22c-.2.43-.53.69-.76.59s-.24-.54,0-1,.53-.69.75-.59S1712.81,317.8,1712.61,318.22Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1570",
    d: "M1714.46,320.83a.8.8,0,0,1-1.52.29.71.71,0,0,1,.65-.73A.7.7,0,0,1,1714.46,320.83Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1571",
    d: "M1710.71,321.07a.51.51,0,0,1-.57.44.51.51,0,1,1,.12-1,.51.51,0,0,1,.45.56Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1572",
    d: "M1719,317.7a.82.82,0,0,1-.8.84.82.82,0,1,1,0-1.63h.1A.76.76,0,0,1,1719,317.7Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1573",
    d: "M1714.49,315.6c-.25.4-.67.58-.94.4s-.3-.63-.06-1,.67-.58,1-.4A.74.74,0,0,1,1714.49,315.6Z",
    className: "fishandtipps_svg__cls-28",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1574",
    d: "M1715.54,317.4",
    className: "fishandtipps_svg__cls-9",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1575",
    d: "M1712.75,318.33c-.19.41-.52.67-.74.57s-.24-.52,0-.93.53-.67.75-.57.23.52,0,.93Z",
    className: "fishandtipps_svg__cls-28",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1576",
    d: "M1714.56,320.87c.06.32-.23.63-.64.71a.68.68,0,0,1-.85-.43c-.06-.31.23-.63.64-.71A.68.68,0,0,1,1714.56,320.87Z",
    className: "fishandtipps_svg__cls-29",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1577",
    d: "M1710.9,321.1a.5.5,0,1,1-.45-.55.49.49,0,0,1,.45.55Z",
    className: "fishandtipps_svg__cls-29",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1578",
    d: "M1719,317.83a.82.82,0,0,1-.78.83.8.8,0,0,1-.82-.78.79.79,0,0,1,.77-.82h.11A.75.75,0,0,1,1719,317.83Z",
    className: "fishandtipps_svg__cls-29",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1579",
    d: "M1710.88,315.69c-.51.63-1.1,1-1.32.81s0-.82.55-1.44,1.1-1,1.31-.81S1711.39,315.07,1710.88,315.69Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1580",
    d: "M1709.34,317.38a.3.3,0,0,1-.36.22.31.31,0,0,1-.22-.37.3.3,0,0,1,.32-.22A.32.32,0,0,1,1709.34,317.38Z",
    className: "fishandtipps_svg__cls-27",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1581",
    d: "M1685.87,284.83a3.93,3.93,0,1,1-3.93-3.92h0A3.94,3.94,0,0,1,1685.87,284.83Z",
    className: "fishandtipps_svg__cls-39",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1582",
    d: "M1685.27,284.83a3.33,3.33,0,1,1-3.33-3.32h0A3.33,3.33,0,0,1,1685.27,284.83Z",
    className: "fishandtipps_svg__cls-40",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1583",
    d: "M1682.81,283.19a1.34,1.34,0,0,1-1.17,1.48,1.31,1.31,0,0,1-1.47-1.16,1.33,1.33,0,0,1,1.16-1.48h.16A1.26,1.26,0,0,1,1682.81,283.19Z",
    className: "fishandtipps_svg__cls-41",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1584",
    d: "M1680.57,285.18a.54.54,0,1,1-.55-.53h0A.54.54,0,0,1,1680.57,285.18Z",
    className: "fishandtipps_svg__cls-41",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1585",
    d: "M1677.27,295.07a2.37,2.37,0,1,1-2.37-2.36h0A2.37,2.37,0,0,1,1677.27,295.07Z",
    className: "fishandtipps_svg__cls-39",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1586",
    d: "M1676.92,295.07a2,2,0,1,1-2-2A2,2,0,0,1,1676.92,295.07Z",
    className: "fishandtipps_svg__cls-40",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1587",
    d: "M1675.43,294.08a.76.76,0,0,1-.8.7h0a.71.71,0,0,1-.8-.62.72.72,0,0,1,.63-.79h.17A.77.77,0,0,1,1675.43,294.08Z",
    className: "fishandtipps_svg__cls-41",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1588",
    d: "M1674.08,295.28a.33.33,0,1,1-.34-.32h0a.33.33,0,0,1,.33.32Z",
    className: "fishandtipps_svg__cls-41",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1589",
    d: "M1741.24,277.25a2.37,2.37,0,1,1-2.37-2.37h0A2.37,2.37,0,0,1,1741.24,277.25Z",
    className: "fishandtipps_svg__cls-39",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1590",
    d: "M1740.88,277.25a2,2,0,1,1-2-2,2,2,0,0,1,2,2Z",
    className: "fishandtipps_svg__cls-40",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1591",
    d: "M1739.39,276.26a.8.8,0,1,1-.88-.7h.08a.75.75,0,0,1,.8.71Z",
    className: "fishandtipps_svg__cls-41",
    transform: "translate(-35.75 -38.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fishandtipps_svg__Path_1592",
    d: "M1738,277.46a.33.33,0,0,1-.65,0,.32.32,0,0,1,.32-.33h0a.32.32,0,0,1,.32.32Z",
    className: "fishandtipps_svg__cls-41",
    transform: "translate(-35.75 -38.86)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishandtipps);
export default __webpack_public_path__ + "static/media/fishandtipps.eaadb17ec61195f1320df8803da771ee.svg";
export { ForwardRef as ReactComponent };